import { fromParts, compare } from "../client/src/fable_modules/fable-library.3.7.17/Decimal.js";
import { tryParse } from "../client/src/fable_modules/fable-library.3.7.17/Double.js";
import { Union, Record, FSharpRef } from "../client/src/fable_modules/fable-library.3.7.17/Types.js";
import { isMatch } from "../client/src/fable_modules/fable-library.3.7.17/RegExp.js";
import { tuple_type, list_type, float64_type, bool_type, option_type, union_type, string_type, class_type, record_type, int32_type } from "../client/src/fable_modules/fable-library.3.7.17/Reflection.js";
import { map } from "../client/src/fable_modules/fable-library.3.7.17/Option.js";
import { filter, sortByDescending, contains, map as map_2, toArray, length, empty, ofArray } from "../client/src/fable_modules/fable-library.3.7.17/List.js";
import { map as map_1 } from "../client/src/fable_modules/fable-library.3.7.17/Array.js";
import { format, join, split } from "../client/src/fable_modules/fable-library.3.7.17/String.js";
import { comparePrimitives, safeHash, equals } from "../client/src/fable_modules/fable-library.3.7.17/Util.js";

export function Validation_max(count, value) {
    if (value.length > count) {
        return void 0;
    }
    else {
        return value;
    }
}

export function Validation_min(count, value) {
    if (value.length < count) {
        return void 0;
    }
    else {
        return value;
    }
}

export function Validation_maxNumInt(maxVal, value) {
    if (value > maxVal) {
        return void 0;
    }
    else {
        return value;
    }
}

export function Validation_minNumInt(minVal, value) {
    if (value < minVal) {
        return void 0;
    }
    else {
        return value;
    }
}

export function Validation_maxNumDecimal(maxVal, value) {
    if (compare(value, maxVal) > 0) {
        return void 0;
    }
    else {
        return value;
    }
}

export function Validation_minNumDecimal(minVal, value) {
    if (compare(value, minVal) < 0) {
        return void 0;
    }
    else {
        return value;
    }
}

export function Validation_maxNumFloat(maxVal, value) {
    if (value > maxVal) {
        return void 0;
    }
    else {
        return value;
    }
}

export function Validation_minNumFloat(minVal, value) {
    if (value < minVal) {
        return void 0;
    }
    else {
        return value;
    }
}

export function Validation_nonNegativeFloat(value) {
    if (value >= 0) {
        return value;
    }
    else {
        return void 0;
    }
}

export function Validation_parseFloat(value) {
    let matchValue;
    let outArg = 0;
    matchValue = [tryParse(value, new FSharpRef(() => outArg, (v) => {
        outArg = v;
    })), outArg];
    if (matchValue[0]) {
        return matchValue[1];
    }
    else {
        return void 0;
    }
}

export function Validation_validEmail(value) {
    if (value === "") {
        return void 0;
    }
    else if (!isMatch(/^[\w!#$%&'*+\-\/=?^_`{|}~]+(\.[\w!#$%&'*+\-\/=?^_`{|}~]+)*@([A-Za-z0-9-]+(\.[A-Za-z0-9-]+)*\.)+[A-Za-z]{2,}$/gu, value)) {
        return void 0;
    }
    else {
        return value;
    }
}

export class Integer extends Record {
    constructor(Value) {
        super();
        this.Value = (Value | 0);
    }
}

export function Integer$reflection() {
    return record_type("Domain.Integer", [], Integer, () => [["Value", int32_type]]);
}

export function Integer_get_Create() {
    return (arg_1) => map(Integer___UnsafeCreate_Z524259A4, Validation_minNumInt(0, arg_1));
}

export function Integer___UnsafeCreate_Z524259A4(value) {
    return new Integer(value);
}

export function Integer___UnsafeUnwrap_311D730D(x) {
    return x.Value;
}

export class Decimal extends Record {
    constructor(Value) {
        super();
        this.Value = Value;
    }
}

export function Decimal$reflection() {
    return record_type("Domain.Decimal", [], Decimal, () => [["Value", class_type("System.Decimal")]]);
}

export function Decimal_get_Create() {
    let f1;
    const minVal = fromParts(0, 0, 0, false, 0);
    f1 = ((value) => Validation_minNumDecimal(minVal, value));
    return (arg_1) => map(Decimal___UnsafeCreate_32C73145, f1(arg_1));
}

export function Decimal___UnsafeCreate_32C73145(value) {
    return new Decimal(value);
}

export function Decimal___UnsafeUnwrap_5C134760(x) {
    return x.Value;
}

export class NonEmptyString extends Record {
    constructor(Value) {
        super();
        this.Value = Value;
    }
}

export function NonEmptyString$reflection() {
    return record_type("Domain.NonEmptyString", [], NonEmptyString, () => [["Value", string_type]]);
}

export function NonEmptyString_get_Create() {
    return (arg_1) => map(NonEmptyString___UnsafeCreate_Z721C83C5, Validation_min(1, arg_1));
}

export function NonEmptyString___UnsafeCreate_Z721C83C5(value) {
    return new NonEmptyString(value);
}

export function NonEmptyString___UnsafeUnwrap_Z73AD07C(x) {
    return x.Value;
}

export class EmptyString extends Record {
    constructor(Value) {
        super();
        this.Value = Value;
    }
}

export function EmptyString$reflection() {
    return record_type("Domain.EmptyString", [], EmptyString, () => [["Value", string_type]]);
}

export function EmptyString_get_Create() {
    return (arg_1) => map(EmptyString___UnsafeCreate_Z721C83C5, Validation_min(0, arg_1));
}

export function EmptyString___UnsafeCreate_Z721C83C5(value) {
    return new EmptyString(value);
}

export function EmptyString___UnsafeUnwrap_66019AEB(x) {
    return x.Value;
}

export class FilePath extends Record {
    constructor(Value) {
        super();
        this.Value = Value;
    }
}

export function FilePath$reflection() {
    return record_type("Domain.FilePath", [], FilePath, () => [["Value", string_type]]);
}

export class Email extends Record {
    constructor(Value) {
        super();
        this.Value = Value;
    }
}

export function Email$reflection() {
    return record_type("Domain.Email", [], Email, () => [["Value", string_type]]);
}

export function Email_get_Create() {
    return (arg_1) => map(Email___UnsafeCreate_Z721C83C5, Validation_validEmail(arg_1));
}

export function Email___UnsafeCreate_Z721C83C5(value) {
    return new Email(value);
}

export function Email___UnsafeUnwrap_Z27D11339(x) {
    return x.Value;
}

export function EmailList_toList(emails) {
    if (emails != null) {
        return ofArray(map_1(Email___UnsafeCreate_Z721C83C5, split(emails, [";"], null, 0)));
    }
    else {
        return empty();
    }
}

export function EmailList_fromList(emails) {
    if (length(emails) === 0) {
        return void 0;
    }
    else {
        return join(";", toArray(map_2(Email___UnsafeUnwrap_Z27D11339, emails)));
    }
}

export class PhoneNumber extends Record {
    constructor(Value) {
        super();
        this.Value = Value;
    }
}

export function PhoneNumber$reflection() {
    return record_type("Domain.PhoneNumber", [], PhoneNumber, () => [["Value", string_type]]);
}

export function PhoneNumber_get_Create() {
    return (arg_1) => map(PhoneNumber___UnsafeCreate_Z721C83C5, Validation_min(1, arg_1));
}

export function PhoneNumber___UnsafeCreate_Z721C83C5(value) {
    return new PhoneNumber(value);
}

export function PhoneNumber___UnsafeUnwrap_23E45174(x) {
    return x.Value;
}

export class VatNumber extends Record {
    constructor(Value) {
        super();
        this.Value = Value;
    }
}

export function VatNumber$reflection() {
    return record_type("Domain.VatNumber", [], VatNumber, () => [["Value", string_type]]);
}

export function VatNumber_get_Create() {
    return (arg_1) => map(VatNumber___UnsafeCreate_Z721C83C5, Validation_min(1, arg_1));
}

export function VatNumber___UnsafeCreate_Z721C83C5(value) {
    return new VatNumber(value);
}

export function VatNumber___UnsafeUnwrap_18C04ACB(x) {
    return x.Value;
}

export class KboNumber extends Record {
    constructor(Value) {
        super();
        this.Value = Value;
    }
}

export function KboNumber$reflection() {
    return record_type("Domain.KboNumber", [], KboNumber, () => [["Value", string_type]]);
}

export function KboNumber_get_Create() {
    return (arg_1) => map(KboNumber___UnsafeCreate_Z721C83C5, Validation_min(1, arg_1));
}

export function KboNumber___UnsafeCreate_Z721C83C5(value) {
    return new KboNumber(value);
}

export function KboNumber___UnsafeUnwrap_146F846E(x) {
    return x.Value;
}

export class BankAccount extends Record {
    constructor(Value) {
        super();
        this.Value = Value;
    }
}

export function BankAccount$reflection() {
    return record_type("Domain.BankAccount", [], BankAccount, () => [["Value", string_type]]);
}

export function BankAccount_Create_Z721C83C5(value) {
    return new BankAccount(value);
}

export function BankAccount___UnsafeCreate_Z721C83C5(value) {
    return new BankAccount(value);
}

export function BankAccount___UnsafeUnwrap_Z2C38F894(x) {
    return x.Value;
}

export class NationalInsuranceNumber extends Record {
    constructor(Value) {
        super();
        this.Value = Value;
    }
}

export function NationalInsuranceNumber$reflection() {
    return record_type("Domain.NationalInsuranceNumber", [], NationalInsuranceNumber, () => [["Value", string_type]]);
}

export function NationalInsuranceNumber_Create_Z721C83C5(value) {
    return new NationalInsuranceNumber(value);
}

export function NationalInsuranceNumber___UnsafeCreate_Z721C83C5(value) {
    return new NationalInsuranceNumber(value);
}

export function NationalInsuranceNumber___UnsafeUnwrap_Z19EB54D4(x) {
    return x.Value;
}

export class PersonIdOvam extends Record {
    constructor(Value) {
        super();
        this.Value = Value;
    }
}

export function PersonIdOvam$reflection() {
    return record_type("Domain.PersonIdOvam", [], PersonIdOvam, () => [["Value", string_type]]);
}

export function PersonIdOvam_Create_Z721C83C5(value) {
    return new PersonIdOvam(value);
}

export function PersonIdOvam___UnsafeCreate_Z721C83C5(value) {
    return new PersonIdOvam(value);
}

export function PersonIdOvam___UnsafeUnwrap_ZCAC45BA(x) {
    return x.Value;
}

export class PartnerType extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["Partner", "Syndic"];
    }
}

export function PartnerType$reflection() {
    return union_type("Domain.PartnerType", [], PartnerType, () => [[], []]);
}

export class Region extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["WestFlanders", "EastFlanders", "Antwerp", "FlemishBrabant", "Limburg"];
    }
}

export function Region$reflection() {
    return union_type("Domain.Region", [], Region, () => [[], [], [], [], []]);
}

export class InvoicePricing extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["PrivatePerson", "RealEstateCustomer"];
    }
}

export function InvoicePricing$reflection() {
    return union_type("Domain.InvoicePricing", [], InvoicePricing, () => [[], []]);
}

export function InvoicePricingModule_string(invoicePricing) {
    if (invoicePricing.tag === 1) {
        return "Makelaar";
    }
    else {
        return "Particulier";
    }
}

export class ProductType extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["Asbestos_Certificate_Appartment", "Asbestos_Certificate_Studio", "Asbestos_Certificate_Woonuis", "Asbestos_Garage", "Sample_Mix_General", "Sample_Mix_Pipe_Insulation", "Location_Visit_Sampling", "Sample_Point", "Retribution_OVAM", "Asbestos_Handelshuis", "Asbestos_Handelsgelijkvloers", "Asbestos_Industrie", "Asbestos_CoveredOpenParkingSpace", "Asbestos_HouseWithWarehouse", "Asbestos_Horeca", "Asbestos_Landbouw", "Asbestos_Kantoor", "Asbestos_GemeneDelen", "Manual_Invoice", "UrgentAsbestos_Certificate_Appartment", "UrgentAsbestos_Certificate_Studio", "UrgentAsbestos_Certificate_Woonuis", "UrgentAsbestos_Garage", "UrgentSample_Mix_General", "UrgentSample_Mix_Pipe_Insulation", "UrgentLocation_Visit_Sampling", "UrgentSample_Point", "UrgentAsbestos_Handelshuis", "UrgentAsbestos_Handelsgelijkvloers", "UrgentAsbestos_Industrie", "UrgentAsbestos_CoveredOpenParkingSpace", "UrgentAsbestos_HouseWithWarehouse", "UrgentAsbestos_Horeca", "UrgentAsbestos_Landbouw", "UrgentAsbestos_Kantoor", "UrgentAsbestos_GemeneDelen", "Person_Asbestos_Certificate_Appartment", "Person_Asbestos_Certificate_Studio", "Person_Asbestos_Certificate_Woonuis", "Person_Asbestos_Garage", "Person_Sample_Mix_General", "Person_Sample_Mix_Pipe_Insulation", "Person_Location_Visit_Sampling", "Person_Sample_Point", "Person_Retribution_OVAM", "Person_Asbestos_Handelshuis", "Person_Asbestos_Handelsgelijkvloers", "Person_Asbestos_Industrie", "Person_Asbestos_CoveredOpenParkingSpace", "Person_Asbestos_HouseWithWarehouse", "Person_Asbestos_Horeca", "Person_Asbestos_Landbouw", "Person_Asbestos_Kantoor", "Person_Asbestos_GemeneDelen", "UrgentPerson_Asbestos_Certificate_Appartment", "UrgentPerson_Asbestos_Certificate_Studio", "UrgentPerson_Asbestos_Certificate_Woonuis", "UrgentPerson_Asbestos_Garage", "UrgentPerson_Sample_Mix_General", "UrgentPerson_Sample_Mix_Pipe_Insulation", "UrgentPerson_Location_Visit_Sampling", "UrgentPerson_Sample_Point", "UrgentPerson_Asbestos_Handelshuis", "UrgentPerson_Asbestos_Handelsgelijkvloers", "UrgentPerson_Asbestos_Industrie", "UrgentPerson_Asbestos_CoveredOpenParkingSpace", "UrgentPerson_Asbestos_HouseWithWarehouse", "UrgentPerson_Asbestos_Horeca", "UrgentPerson_Asbestos_Landbouw", "UrgentPerson_Asbestos_Kantoor", "UrgentPerson_Asbestos_GemeneDelen"];
    }
}

export function ProductType$reflection() {
    return union_type("Domain.ProductType", [], ProductType, () => [[], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], []]);
}

export class ProductTypeUrgencyConverter {
    constructor() {
    }
}

export function ProductTypeUrgencyConverter$reflection() {
    return class_type("Domain.ProductTypeUrgencyConverter", void 0, ProductTypeUrgencyConverter);
}

export function ProductTypeUrgencyConverter_GetProductType(value, urgentOrderPrivate, invoicePricing) {
    const value_1 = (invoicePricing.tag === 1) ? value : ((value.tag === 0) ? (new ProductType(36)) : ((value.tag === 1) ? (new ProductType(37)) : ((value.tag === 2) ? (new ProductType(38)) : ((value.tag === 3) ? (new ProductType(39)) : ((value.tag === 14) ? (new ProductType(50)) : ((value.tag === 16) ? (new ProductType(52)) : ((value.tag === 15) ? (new ProductType(51)) : ((value.tag === 4) ? (new ProductType(40)) : ((value.tag === 5) ? (new ProductType(41)) : ((value.tag === 6) ? (new ProductType(42)) : ((value.tag === 7) ? (new ProductType(43)) : ((value.tag === 8) ? (new ProductType(44)) : ((value.tag === 9) ? (new ProductType(45)) : ((value.tag === 10) ? (new ProductType(46)) : ((value.tag === 11) ? (new ProductType(47)) : ((value.tag === 12) ? (new ProductType(48)) : ((value.tag === 13) ? (new ProductType(49)) : ((value.tag === 18) ? (new ProductType(18)) : value))))))))))))))))));
    if (urgentOrderPrivate) {
        switch (value_1.tag) {
            case 1: {
                return new ProductType(20);
            }
            case 2: {
                return new ProductType(21);
            }
            case 3: {
                return new ProductType(22);
            }
            case 14: {
                return new ProductType(32);
            }
            case 16: {
                return new ProductType(34);
            }
            case 17: {
                return new ProductType(35);
            }
            case 15: {
                return new ProductType(33);
            }
            case 4: {
                return new ProductType(23);
            }
            case 5: {
                return new ProductType(24);
            }
            case 6: {
                return new ProductType(25);
            }
            case 7: {
                return new ProductType(26);
            }
            case 8: {
                return new ProductType(8);
            }
            case 9: {
                return new ProductType(27);
            }
            case 10: {
                return new ProductType(28);
            }
            case 11: {
                return new ProductType(29);
            }
            case 12: {
                return new ProductType(30);
            }
            case 13: {
                return new ProductType(31);
            }
            case 18: {
                return new ProductType(18);
            }
            case 19: {
                return new ProductType(19);
            }
            case 20: {
                return new ProductType(20);
            }
            case 21: {
                return new ProductType(21);
            }
            case 23: {
                return new ProductType(23);
            }
            case 24: {
                return new ProductType(24);
            }
            case 25: {
                return new ProductType(25);
            }
            case 26: {
                return new ProductType(26);
            }
            case 22: {
                return new ProductType(22);
            }
            case 27: {
                return new ProductType(27);
            }
            case 29: {
                return new ProductType(29);
            }
            case 28: {
                return new ProductType(28);
            }
            case 30: {
                return new ProductType(30);
            }
            case 31: {
                return new ProductType(31);
            }
            case 32: {
                return new ProductType(32);
            }
            case 34: {
                return new ProductType(34);
            }
            case 33: {
                return new ProductType(33);
            }
            case 35: {
                return new ProductType(35);
            }
            case 36: {
                return new ProductType(54);
            }
            case 37: {
                return new ProductType(55);
            }
            case 38: {
                return new ProductType(56);
            }
            case 39: {
                return new ProductType(57);
            }
            case 50: {
                return new ProductType(67);
            }
            case 52: {
                return new ProductType(69);
            }
            case 51: {
                return new ProductType(68);
            }
            case 40: {
                return new ProductType(58);
            }
            case 41: {
                return new ProductType(59);
            }
            case 42: {
                return new ProductType(60);
            }
            case 43: {
                return new ProductType(61);
            }
            case 44: {
                return new ProductType(44);
            }
            case 45: {
                return new ProductType(62);
            }
            case 46: {
                return new ProductType(63);
            }
            case 47: {
                return new ProductType(64);
            }
            case 48: {
                return new ProductType(65);
            }
            case 49: {
                return new ProductType(66);
            }
            case 53: {
                return new ProductType(70);
            }
            case 54: {
                return new ProductType(54);
            }
            case 55: {
                return new ProductType(55);
            }
            case 56: {
                return new ProductType(56);
            }
            case 57: {
                return new ProductType(57);
            }
            case 67: {
                return new ProductType(67);
            }
            case 69: {
                return new ProductType(69);
            }
            case 68: {
                return new ProductType(68);
            }
            case 58: {
                return new ProductType(58);
            }
            case 59: {
                return new ProductType(59);
            }
            case 60: {
                return new ProductType(60);
            }
            case 61: {
                return new ProductType(61);
            }
            case 62: {
                return new ProductType(62);
            }
            case 63: {
                return new ProductType(63);
            }
            case 64: {
                return new ProductType(64);
            }
            case 65: {
                return new ProductType(65);
            }
            case 66: {
                return new ProductType(66);
            }
            case 70: {
                return new ProductType(70);
            }
            default: {
                return new ProductType(19);
            }
        }
    }
    else {
        return value_1;
    }
}

export class ProductReferenceNumber extends Record {
    constructor(Value) {
        super();
        this.Value = Value;
    }
}

export function ProductReferenceNumber$reflection() {
    return record_type("Domain.ProductReferenceNumber", [], ProductReferenceNumber, () => [["Value", string_type]]);
}

export function ProductReferenceNumber_Create_Z4266B0E8(value) {
    switch (value.tag) {
        case 1: {
            return ProductReferenceNumber___UnsafeCreate_Z721C83C5("000002");
        }
        case 2: {
            return ProductReferenceNumber___UnsafeCreate_Z721C83C5("000003");
        }
        case 17: {
            return ProductReferenceNumber___UnsafeCreate_Z721C83C5("000004");
        }
        case 3: {
            return ProductReferenceNumber___UnsafeCreate_Z721C83C5("000005");
        }
        case 14: {
            return ProductReferenceNumber___UnsafeCreate_Z721C83C5("000024");
        }
        case 4: {
            return ProductReferenceNumber___UnsafeCreate_Z721C83C5("000011");
        }
        case 5: {
            return ProductReferenceNumber___UnsafeCreate_Z721C83C5("000012");
        }
        case 6: {
            return ProductReferenceNumber___UnsafeCreate_Z721C83C5("000014");
        }
        case 7: {
            return ProductReferenceNumber___UnsafeCreate_Z721C83C5("000010");
        }
        case 8: {
            return ProductReferenceNumber___UnsafeCreate_Z721C83C5("000015");
        }
        case 10: {
            return ProductReferenceNumber___UnsafeCreate_Z721C83C5("000020");
        }
        case 9: {
            return ProductReferenceNumber___UnsafeCreate_Z721C83C5("000021");
        }
        case 11: {
            return ProductReferenceNumber___UnsafeCreate_Z721C83C5("000023");
        }
        case 16: {
            return ProductReferenceNumber___UnsafeCreate_Z721C83C5("000025");
        }
        case 15: {
            return ProductReferenceNumber___UnsafeCreate_Z721C83C5("000026");
        }
        case 12: {
            return ProductReferenceNumber___UnsafeCreate_Z721C83C5("000006");
        }
        case 13: {
            return ProductReferenceNumber___UnsafeCreate_Z721C83C5("000022");
        }
        case 18: {
            return ProductReferenceNumber___UnsafeCreate_Z721C83C5("000100");
        }
        case 19: {
            return ProductReferenceNumber___UnsafeCreate_Z721C83C5("000201");
        }
        case 20: {
            return ProductReferenceNumber___UnsafeCreate_Z721C83C5("000202");
        }
        case 21: {
            return ProductReferenceNumber___UnsafeCreate_Z721C83C5("000203");
        }
        case 23: {
            return ProductReferenceNumber___UnsafeCreate_Z721C83C5("000211");
        }
        case 24: {
            return ProductReferenceNumber___UnsafeCreate_Z721C83C5("000212");
        }
        case 25: {
            return ProductReferenceNumber___UnsafeCreate_Z721C83C5("000214");
        }
        case 26: {
            return ProductReferenceNumber___UnsafeCreate_Z721C83C5("000210");
        }
        case 22: {
            return ProductReferenceNumber___UnsafeCreate_Z721C83C5("000205");
        }
        case 27: {
            return ProductReferenceNumber___UnsafeCreate_Z721C83C5("000221");
        }
        case 29: {
            return ProductReferenceNumber___UnsafeCreate_Z721C83C5("000223");
        }
        case 28: {
            return ProductReferenceNumber___UnsafeCreate_Z721C83C5("000220");
        }
        case 30: {
            return ProductReferenceNumber___UnsafeCreate_Z721C83C5("000206");
        }
        case 31: {
            return ProductReferenceNumber___UnsafeCreate_Z721C83C5("000222");
        }
        case 32: {
            return ProductReferenceNumber___UnsafeCreate_Z721C83C5("000224");
        }
        case 34: {
            return ProductReferenceNumber___UnsafeCreate_Z721C83C5("000225");
        }
        case 33: {
            return ProductReferenceNumber___UnsafeCreate_Z721C83C5("000226");
        }
        case 35: {
            return ProductReferenceNumber___UnsafeCreate_Z721C83C5("000403");
        }
        case 36: {
            return ProductReferenceNumber___UnsafeCreate_Z721C83C5("000401");
        }
        case 37: {
            return ProductReferenceNumber___UnsafeCreate_Z721C83C5("000400");
        }
        case 38: {
            return ProductReferenceNumber___UnsafeCreate_Z721C83C5("000402");
        }
        case 39: {
            return ProductReferenceNumber___UnsafeCreate_Z721C83C5("000404");
        }
        case 50: {
            return ProductReferenceNumber___UnsafeCreate_Z721C83C5("000414");
        }
        case 40: {
            return ProductReferenceNumber___UnsafeCreate_Z721C83C5("000407");
        }
        case 41: {
            return ProductReferenceNumber___UnsafeCreate_Z721C83C5("000408");
        }
        case 42: {
            return ProductReferenceNumber___UnsafeCreate_Z721C83C5("000409");
        }
        case 43: {
            return ProductReferenceNumber___UnsafeCreate_Z721C83C5("000406");
        }
        case 44: {
            return ProductReferenceNumber___UnsafeCreate_Z721C83C5("000015");
        }
        case 46: {
            return ProductReferenceNumber___UnsafeCreate_Z721C83C5("000410");
        }
        case 45: {
            return ProductReferenceNumber___UnsafeCreate_Z721C83C5("000411");
        }
        case 47: {
            return ProductReferenceNumber___UnsafeCreate_Z721C83C5("000413");
        }
        case 52: {
            return ProductReferenceNumber___UnsafeCreate_Z721C83C5("000415");
        }
        case 51: {
            return ProductReferenceNumber___UnsafeCreate_Z721C83C5("000416");
        }
        case 53: {
            return ProductReferenceNumber___UnsafeCreate_Z721C83C5("000403");
        }
        case 48: {
            return ProductReferenceNumber___UnsafeCreate_Z721C83C5("000405");
        }
        case 49: {
            return ProductReferenceNumber___UnsafeCreate_Z721C83C5("000412");
        }
        case 54: {
            return ProductReferenceNumber___UnsafeCreate_Z721C83C5("000501");
        }
        case 55: {
            return ProductReferenceNumber___UnsafeCreate_Z721C83C5("000500");
        }
        case 56: {
            return ProductReferenceNumber___UnsafeCreate_Z721C83C5("000502");
        }
        case 57: {
            return ProductReferenceNumber___UnsafeCreate_Z721C83C5("000504");
        }
        case 67: {
            return ProductReferenceNumber___UnsafeCreate_Z721C83C5("000514");
        }
        case 58: {
            return ProductReferenceNumber___UnsafeCreate_Z721C83C5("000507");
        }
        case 70: {
            return ProductReferenceNumber___UnsafeCreate_Z721C83C5("000503");
        }
        case 59: {
            return ProductReferenceNumber___UnsafeCreate_Z721C83C5("000508");
        }
        case 60: {
            return ProductReferenceNumber___UnsafeCreate_Z721C83C5("000509");
        }
        case 61: {
            return ProductReferenceNumber___UnsafeCreate_Z721C83C5("000506");
        }
        case 63: {
            return ProductReferenceNumber___UnsafeCreate_Z721C83C5("000510");
        }
        case 62: {
            return ProductReferenceNumber___UnsafeCreate_Z721C83C5("000511");
        }
        case 64: {
            return ProductReferenceNumber___UnsafeCreate_Z721C83C5("000513");
        }
        case 69: {
            return ProductReferenceNumber___UnsafeCreate_Z721C83C5("000515");
        }
        case 68: {
            return ProductReferenceNumber___UnsafeCreate_Z721C83C5("000516");
        }
        case 65: {
            return ProductReferenceNumber___UnsafeCreate_Z721C83C5("000505");
        }
        case 66: {
            return ProductReferenceNumber___UnsafeCreate_Z721C83C5("000512");
        }
        default: {
            return ProductReferenceNumber___UnsafeCreate_Z721C83C5("000001");
        }
    }
}

export function ProductReferenceNumber___UnsafeCreate_Z721C83C5(value) {
    return new ProductReferenceNumber(value);
}

export function ProductReferenceNumber___UnsafeUnwrap_Z75335EF8(x) {
    return x.Value;
}

export class CustomerId extends Record {
    constructor(Value) {
        super();
        this.Value = (Value | 0);
    }
}

export function CustomerId$reflection() {
    return record_type("Domain.CustomerId", [], CustomerId, () => [["Value", int32_type]]);
}

export class CustomerCode extends Record {
    constructor(Value) {
        super();
        this.Value = Value;
    }
}

export function CustomerCode$reflection() {
    return record_type("Domain.CustomerCode", [], CustomerCode, () => [["Value", string_type]]);
}

export class LegalRepresentativeId extends Record {
    constructor(Value) {
        super();
        this.Value = (Value | 0);
    }
}

export function LegalRepresentativeId$reflection() {
    return record_type("Domain.LegalRepresentativeId", [], LegalRepresentativeId, () => [["Value", int32_type]]);
}

export class AdiId extends Record {
    constructor(Value) {
        super();
        this.Value = (Value | 0);
    }
}

export function AdiId$reflection() {
    return record_type("Domain.AdiId", [], AdiId, () => [["Value", int32_type]]);
}

export class FileId extends Record {
    constructor(Value) {
        super();
        this.Value = (Value | 0);
    }
}

export function FileId$reflection() {
    return record_type("Domain.FileId", [], FileId, () => [["Value", int32_type]]);
}

export class CompanyId extends Record {
    constructor(Value) {
        super();
        this.Value = (Value | 0);
    }
}

export function CompanyId$reflection() {
    return record_type("Domain.CompanyId", [], CompanyId, () => [["Value", int32_type]]);
}

export class CompanyInfoId extends Record {
    constructor(Value) {
        super();
        this.Value = (Value | 0);
    }
}

export function CompanyInfoId$reflection() {
    return record_type("Domain.CompanyInfoId", [], CompanyInfoId, () => [["Value", int32_type]]);
}

export class DossierId extends Record {
    constructor(Value) {
        super();
        this.Value = (Value | 0);
    }
}

export function DossierId$reflection() {
    return record_type("Domain.DossierId", [], DossierId, () => [["Value", int32_type]]);
}

export function DossierId__toFormattedString(this$) {
    return format('{0:' + "0000000" + '}', this$.Value);
}

export class DossierCode extends Record {
    constructor(Value) {
        super();
        this.Value = Value;
    }
}

export function DossierCode$reflection() {
    return record_type("Domain.DossierCode", [], DossierCode, () => [["Value", string_type]]);
}

export class DossierCommentId extends Record {
    constructor(Value) {
        super();
        this.Value = (Value | 0);
    }
}

export function DossierCommentId$reflection() {
    return record_type("Domain.DossierCommentId", [], DossierCommentId, () => [["Value", int32_type]]);
}

export class QuoteId extends Record {
    constructor(Value) {
        super();
        this.Value = (Value | 0);
    }
}

export function QuoteId$reflection() {
    return record_type("Domain.QuoteId", [], QuoteId, () => [["Value", int32_type]]);
}

export class QuoteDocumentType extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["Internal", "External"];
    }
}

export function QuoteDocumentType$reflection() {
    return union_type("Domain.QuoteDocumentType", [], QuoteDocumentType, () => [[], []]);
}

export function QuoteDocumentType__get_toString(this$) {
    if (this$.tag === 1) {
        return "External";
    }
    else {
        return "Internal";
    }
}

export class QuoteFileType extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["Document", "Image"];
    }
}

export function QuoteFileType$reflection() {
    return union_type("Domain.QuoteFileType", [], QuoteFileType, () => [[], []]);
}

export function QuoteFileType__get_toString(this$) {
    if (this$.tag === 1) {
        return "Image";
    }
    else {
        return "Document";
    }
}

export class QuoteCode extends Record {
    constructor(Value) {
        super();
        this.Value = Value;
    }
}

export function QuoteCode$reflection() {
    return record_type("Domain.QuoteCode", [], QuoteCode, () => [["Value", string_type]]);
}

export class InvoiceId extends Record {
    constructor(Value) {
        super();
        this.Value = (Value | 0);
    }
}

export function InvoiceId$reflection() {
    return record_type("Domain.InvoiceId", [], InvoiceId, () => [["Value", int32_type]]);
}

export class InvoiceLineId extends Record {
    constructor(Value) {
        super();
        this.Value = (Value | 0);
    }
}

export function InvoiceLineId$reflection() {
    return record_type("Domain.InvoiceLineId", [], InvoiceLineId, () => [["Value", int32_type]]);
}

export class InvoicingId extends Record {
    constructor(Value) {
        super();
        this.Value = Value;
    }
}

export function InvoicingId$reflection() {
    return record_type("Domain.InvoicingId", [], InvoicingId, () => [["Value", string_type]]);
}

export class DigitalSignatureId extends Record {
    constructor(Value) {
        super();
        this.Value = (Value | 0);
    }
}

export function DigitalSignatureId$reflection() {
    return record_type("Domain.DigitalSignatureId", [], DigitalSignatureId, () => [["Value", int32_type]]);
}

export class AppointmentId extends Record {
    constructor(Value) {
        super();
        this.Value = (Value | 0);
    }
}

export function AppointmentId$reflection() {
    return record_type("Domain.AppointmentId", [], AppointmentId, () => [["Value", int32_type]]);
}

export class AppointmentCommentId extends Record {
    constructor(Value) {
        super();
        this.Value = (Value | 0);
    }
}

export function AppointmentCommentId$reflection() {
    return record_type("Domain.AppointmentCommentId", [], AppointmentCommentId, () => [["Value", int32_type]]);
}

export class AppointmentConfirmationId extends Record {
    constructor(Value) {
        super();
        this.Value = (Value | 0);
    }
}

export function AppointmentConfirmationId$reflection() {
    return record_type("Domain.AppointmentConfirmationId", [], AppointmentConfirmationId, () => [["Value", int32_type]]);
}

export class PlaceDescriptionAppointmentId extends Record {
    constructor(Value) {
        super();
        this.Value = (Value | 0);
    }
}

export function PlaceDescriptionAppointmentId$reflection() {
    return record_type("Domain.PlaceDescriptionAppointmentId", [], PlaceDescriptionAppointmentId, () => [["Value", int32_type]]);
}

export class AvailabilityCalendarEventId extends Record {
    constructor(Value) {
        super();
        this.Value = (Value | 0);
    }
}

export function AvailabilityCalendarEventId$reflection() {
    return record_type("Domain.AvailabilityCalendarEventId", [], AvailabilityCalendarEventId, () => [["Value", int32_type]]);
}

export class QuoteDocumentId extends Record {
    constructor(Value) {
        super();
        this.Value = (Value | 0);
    }
}

export function QuoteDocumentId$reflection() {
    return record_type("Domain.QuoteDocumentId", [], QuoteDocumentId, () => [["Value", int32_type]]);
}

export class PartnerId extends Record {
    constructor(Value) {
        super();
        this.Value = (Value | 0);
    }
}

export function PartnerId$reflection() {
    return record_type("Domain.PartnerId", [], PartnerId, () => [["Value", int32_type]]);
}

export class QuoteDocumentUploadResult extends Record {
    constructor(Id, DocumentFilePath, DocumentFileName, DocumentType$, DocumentFileType) {
        super();
        this.Id = Id;
        this.DocumentFilePath = DocumentFilePath;
        this.DocumentFileName = DocumentFileName;
        this.DocumentType = DocumentType$;
        this.DocumentFileType = DocumentFileType;
    }
}

export function QuoteDocumentUploadResult$reflection() {
    return record_type("Domain.QuoteDocumentUploadResult", [], QuoteDocumentUploadResult, () => [["Id", QuoteDocumentId$reflection()], ["DocumentFilePath", FilePath$reflection()], ["DocumentFileName", string_type], ["DocumentType", QuoteDocumentType$reflection()], ["DocumentFileType", QuoteFileType$reflection()]]);
}

export class PartnerCode extends Record {
    constructor(Value) {
        super();
        this.Value = Value;
    }
}

export function PartnerCode$reflection() {
    return record_type("Domain.PartnerCode", [], PartnerCode, () => [["Value", string_type]]);
}

export function PartnerCode_get_Create() {
    return (arg_1) => map(PartnerCode___UnsafeCreate_Z721C83C5, Validation_min(1, arg_1));
}

export function PartnerCode___UnsafeCreate_Z721C83C5(value) {
    return new PartnerCode(value);
}

export function PartnerCode___UnsafeUnwrap_786B17C8(x) {
    return x.Value;
}

export class SignatureCode extends Record {
    constructor(Value) {
        super();
        this.Value = Value;
    }
}

export function SignatureCode$reflection() {
    return record_type("Domain.SignatureCode", [], SignatureCode, () => [["Value", string_type]]);
}

export class DossierEventLogId extends Record {
    constructor(Value) {
        super();
        this.Value = (Value | 0);
    }
}

export function DossierEventLogId$reflection() {
    return record_type("Domain.DossierEventLogId", [], DossierEventLogId, () => [["Value", int32_type]]);
}

export class DossierKind extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["AIA", "EPC"];
    }
}

export function DossierKind$reflection() {
    return union_type("Domain.DossierKind", [], DossierKind, () => [[], []]);
}

export function DossierKindModule_chipLabel(kind) {
    if (kind.tag === 1) {
        return "EPC";
    }
    else {
        return "AIA";
    }
}

export class EpcScore extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["EpcA", "EpcB", "EpcC", "EpcD", "EpcE", "EpcF"];
    }
}

export function EpcScore$reflection() {
    return union_type("Domain.EpcScore", [], EpcScore, () => [[], [], [], [], [], []]);
}

export function EpcScore_get_list() {
    return ofArray([new EpcScore(0), new EpcScore(1), new EpcScore(2), new EpcScore(3), new EpcScore(4), new EpcScore(5)]);
}

export function EpcScore__get_label(this$) {
    switch (this$.tag) {
        case 1: {
            return "B";
        }
        case 2: {
            return "C";
        }
        case 3: {
            return "D";
        }
        case 4: {
            return "E";
        }
        case 5: {
            return "F";
        }
        default: {
            return "A";
        }
    }
}

export class WoonhuisBuildingForm extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["OpenBebouwing", "HalfopenBebouwing", "GeslotenBebouwing"];
    }
}

export function WoonhuisBuildingForm$reflection() {
    return union_type("Domain.WoonhuisBuildingForm", [], WoonhuisBuildingForm, () => [[], [], []]);
}

export function WoonhuisBuildingForm_get_list() {
    return ofArray([new WoonhuisBuildingForm(0), new WoonhuisBuildingForm(1), new WoonhuisBuildingForm(2)]);
}

export function WoonhuisBuildingForm__get_label(this$) {
    switch (this$.tag) {
        case 1: {
            return "Halfopen bebouwing (HOB)";
        }
        case 2: {
            return "Gesloten bebouwing (GB)";
        }
        default: {
            return "Open bebouwing (OB)";
        }
    }
}

export class CommentSource extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["System", "Admin", "Adi", "Customer", "Partner"];
    }
}

export function CommentSource$reflection() {
    return union_type("Domain.CommentSource", [], CommentSource, () => [[], [], [], [], []]);
}

export class CommentType extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["Adi", "Partner", "Internal"];
    }
}

export function CommentType$reflection() {
    return union_type("Domain.CommentType", [], CommentType, () => [[], [], []]);
}

export function CommentType__get_toString(this$) {
    switch (this$.tag) {
        case 1: {
            return "Partner";
        }
        case 2: {
            return "Internal";
        }
        default: {
            return "ADI";
        }
    }
}

export class Address extends Record {
    constructor(Street, Number$, Bus, PostalCode, City) {
        super();
        this.Street = Street;
        this.Number = Number$;
        this.Bus = Bus;
        this.PostalCode = PostalCode;
        this.City = City;
    }
}

export function Address$reflection() {
    return record_type("Domain.Address", [], Address, () => [["Street", NonEmptyString$reflection()], ["Number", NonEmptyString$reflection()], ["Bus", option_type(NonEmptyString$reflection())], ["PostalCode", NonEmptyString$reflection()], ["City", NonEmptyString$reflection()]]);
}

export class AppointmentConfirmation extends Record {
    constructor(Id, AreSampelsUploaded, PointSampleCount, MixedSampleCount, MixedSamplePipeInsulationCount, AdhesiveSampleCount, NightShift, SundayShift, GoingBackToSite, AppointmentId, UrgentOrderCib, UrgentOrderPrivate) {
        super();
        this.Id = Id;
        this.AreSampelsUploaded = AreSampelsUploaded;
        this.PointSampleCount = PointSampleCount;
        this.MixedSampleCount = MixedSampleCount;
        this.MixedSamplePipeInsulationCount = MixedSamplePipeInsulationCount;
        this.AdhesiveSampleCount = AdhesiveSampleCount;
        this.NightShift = NightShift;
        this.SundayShift = SundayShift;
        this.GoingBackToSite = GoingBackToSite;
        this.AppointmentId = AppointmentId;
        this.UrgentOrderCib = UrgentOrderCib;
        this.UrgentOrderPrivate = UrgentOrderPrivate;
    }
}

export function AppointmentConfirmation$reflection() {
    return record_type("Domain.AppointmentConfirmation", [], AppointmentConfirmation, () => [["Id", AppointmentConfirmationId$reflection()], ["AreSampelsUploaded", bool_type], ["PointSampleCount", Integer$reflection()], ["MixedSampleCount", Integer$reflection()], ["MixedSamplePipeInsulationCount", Integer$reflection()], ["AdhesiveSampleCount", Integer$reflection()], ["NightShift", bool_type], ["SundayShift", bool_type], ["GoingBackToSite", bool_type], ["AppointmentId", AppointmentId$reflection()], ["UrgentOrderCib", bool_type], ["UrgentOrderPrivate", bool_type]]);
}

export class AppointmentStatus extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["AppointmentMade", "AwaitingSampleMailing", "AppointmentCompleted", "Cancelled"];
    }
}

export function AppointmentStatus$reflection() {
    return union_type("Domain.AppointmentStatus", [], AppointmentStatus, () => [[], [], [], []]);
}

export function AppointmentStatus_get_list() {
    return ofArray([new AppointmentStatus(0), new AppointmentStatus(1), new AppointmentStatus(2), new AppointmentStatus(3)]);
}

export class Appointment extends Record {
    constructor(Id, Status, DossierCode, DossierId, AdiId, StartTime, EndTime, CalendarServiceEventId) {
        super();
        this.Id = Id;
        this.Status = Status;
        this.DossierCode = DossierCode;
        this.DossierId = DossierId;
        this.AdiId = AdiId;
        this.StartTime = StartTime;
        this.EndTime = EndTime;
        this.CalendarServiceEventId = CalendarServiceEventId;
    }
}

export function Appointment$reflection() {
    return record_type("Domain.Appointment", [], Appointment, () => [["Id", AppointmentId$reflection()], ["Status", AppointmentStatus$reflection()], ["DossierCode", DossierCode$reflection()], ["DossierId", DossierId$reflection()], ["AdiId", AdiId$reflection()], ["StartTime", class_type("System.DateTimeOffset")], ["EndTime", class_type("System.DateTimeOffset")], ["CalendarServiceEventId", option_type(string_type)]]);
}

export class PlaceDescriptionAppointment extends Record {
    constructor(Id, Status, AdiId, StartTime, EndTime, CalendarServiceEventId, Note) {
        super();
        this.Id = Id;
        this.Status = Status;
        this.AdiId = AdiId;
        this.StartTime = StartTime;
        this.EndTime = EndTime;
        this.CalendarServiceEventId = CalendarServiceEventId;
        this.Note = Note;
    }
}

export function PlaceDescriptionAppointment$reflection() {
    return record_type("Domain.PlaceDescriptionAppointment", [], PlaceDescriptionAppointment, () => [["Id", PlaceDescriptionAppointmentId$reflection()], ["Status", AppointmentStatus$reflection()], ["AdiId", AdiId$reflection()], ["StartTime", class_type("System.DateTimeOffset")], ["EndTime", class_type("System.DateTimeOffset")], ["CalendarServiceEventId", option_type(string_type)], ["Note", string_type]]);
}

export class DossierComment extends Record {
    constructor(Id, DossierId, Comment$, CommentSource, CommentType, Name, CreatedOn, UpdatedOn) {
        super();
        this.Id = Id;
        this.DossierId = DossierId;
        this.Comment = Comment$;
        this.CommentSource = CommentSource;
        this.CommentType = CommentType;
        this.Name = Name;
        this.CreatedOn = CreatedOn;
        this.UpdatedOn = UpdatedOn;
    }
}

export function DossierComment$reflection() {
    return record_type("Domain.DossierComment", [], DossierComment, () => [["Id", DossierCommentId$reflection()], ["DossierId", AppointmentId$reflection()], ["Comment", string_type], ["CommentSource", CommentSource$reflection()], ["CommentType", CommentType$reflection()], ["Name", option_type(NonEmptyString$reflection())], ["CreatedOn", class_type("System.DateTimeOffset")], ["UpdatedOn", class_type("System.DateTimeOffset")]]);
}

export class DigitalSignature extends Record {
    constructor(Id, SignatureCode, CreatedOn, ExpiresAt, Signed, SignedAt) {
        super();
        this.Id = Id;
        this.SignatureCode = SignatureCode;
        this.CreatedOn = CreatedOn;
        this.ExpiresAt = ExpiresAt;
        this.Signed = Signed;
        this.SignedAt = SignedAt;
    }
}

export function DigitalSignature$reflection() {
    return record_type("Domain.DigitalSignature", [], DigitalSignature, () => [["Id", DigitalSignatureId$reflection()], ["SignatureCode", SignatureCode$reflection()], ["CreatedOn", class_type("System.DateTimeOffset")], ["ExpiresAt", class_type("System.DateTimeOffset")], ["Signed", bool_type], ["SignedAt", option_type(class_type("System.DateTimeOffset"))]]);
}

export class Compensation extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["NoCompensation", "Ten", "Twenty", "Thirty", "Forty", "Fifty", "Sixty", "Seventy", "Eighty", "Ninety", "Hundred", "Custom"];
    }
}

export function Compensation$reflection() {
    return union_type("Domain.Compensation", [], Compensation, () => [[], [], [], [], [], [], [], [], [], [], [], [["Item", Decimal$reflection()]]]);
}

export function Compensation_get_DefaultCompensation() {
    return new Compensation(2);
}

export class InspectionLocation extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["Public_Federal", "Public_FlemishRegion", "Public_LocalRegional", "Public_Other", "NonResidential_Handelshuis", "NonResidential_Handelsgelijkvloers", "NonResidential_Horeca", "NonResidential_Industrie", "NonResidential_Jeugdvereniging", "NonResidential_Kantoor", "NonResidential_Landbouw", "NonResidential_LogeerfunctieOfBedAndBreakfast", "NonResidential_Other", "Residential_Woonhuis", "Residential_Studio", "Residential_EenkamerAppartement", "Residential_Appartement", "Residential_CollectiefWoongebouw", "Residential_MeerdereAppartement", "Residential_Garage", "Residential_OverdekteOpenStaanplaats", "Residential_WoningMagazijn", "Residential_GemeneDelen", "Residential_Other", "InSocialUse_Education_AGION", "InSocialUse_Education_GO", "InSocialUse_Education_HigherEducation", "InSocialUse_Religion", "InSocialUse_SportsRecreation", "InSocialUse_CareFacility", "InSocialUse_Other"];
    }
}

export function InspectionLocation$reflection() {
    return union_type("Domain.InspectionLocation", [], InspectionLocation, () => [[], [], [], [["Item", NonEmptyString$reflection()]], [], [], [], [], [], [], [], [], [["Item", NonEmptyString$reflection()]], [], [], [], [], [], [], [], [], [], [], [["Item", NonEmptyString$reflection()]], [], [], [], [], [], [], [["Item", NonEmptyString$reflection()]]]);
}

export function InspectionLocation_get_list() {
    return ofArray([new InspectionLocation(0), new InspectionLocation(1), new InspectionLocation(2), new InspectionLocation(3, new NonEmptyString("")), new InspectionLocation(4), new InspectionLocation(5), new InspectionLocation(6), new InspectionLocation(7), new InspectionLocation(8), new InspectionLocation(9), new InspectionLocation(10), new InspectionLocation(11), new InspectionLocation(12, new NonEmptyString("")), new InspectionLocation(13), new InspectionLocation(14), new InspectionLocation(15), new InspectionLocation(16), new InspectionLocation(17), new InspectionLocation(18), new InspectionLocation(19), new InspectionLocation(20), new InspectionLocation(21), new InspectionLocation(22), new InspectionLocation(23, new NonEmptyString("")), new InspectionLocation(24), new InspectionLocation(25), new InspectionLocation(26), new InspectionLocation(27), new InspectionLocation(28), new InspectionLocation(29), new InspectionLocation(30, new NonEmptyString(""))]);
}

export class InspectionLocationExtra extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["Berging", "Staanplaats", "GarageBox"];
    }
}

export function InspectionLocationExtra$reflection() {
    return union_type("Domain.InspectionLocationExtra", [], InspectionLocationExtra, () => [[], [], []]);
}

export class AsbestInventory extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["Handover", "ToWork", "UpdtAsbestInvtCertificate", "DemolitionWihtoutSOP", "DemolitionWithSOP", "Employer", "TransferWithVoluntaryAdditionalResearch", "Generic", "GenericWithVoluntaryAdditionalResearch", "SharedArea", "SharedAreaObligation2027", "GeneralObligation2032", "Other"];
    }
}

export function AsbestInventory$reflection() {
    return union_type("Domain.AsbestInventory", [], AsbestInventory, () => [[], [], [], [], [], [], [], [], [], [], [], [], []]);
}

export class TypeOfDossier extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["AsbestInventoryType", "SamplingType"];
    }
}

export function TypeOfDossier$reflection() {
    return union_type("Domain.TypeOfDossier", [], TypeOfDossier, () => [[["Item", AsbestInventory$reflection()]], []]);
}

export class DossierClient extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["Owner", "Trustee", "AssociationOfCoowners"];
    }
}

export function DossierClient$reflection() {
    return union_type("Domain.DossierClient", [], DossierClient, () => [[], [], []]);
}

export function DossierClient__get_toString(this$) {
    switch (this$.tag) {
        case 1: {
            return "gevolmachtigde";
        }
        case 2: {
            return "Vereniging van Medeëigenaars";
        }
        default: {
            return "eigenaar";
        }
    }
}

export class OwnerStatus extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["PrivatePerson", "SocialHousingCompany", "LessorViaSocialBureau", "GovFlemishRegion", "GovLocalRegional", "GovFederal", "Company", "VME", "Other"];
    }
}

export function OwnerStatus$reflection() {
    return union_type("Domain.OwnerStatus", [], OwnerStatus, () => [[], [], [], [], [], [], [], [], []]);
}

export function OwnerStatus__get_toString(this$) {
    switch (this$.tag) {
        case 1: {
            return "Sociale huisvestingsmaatschappij";
        }
        case 2: {
            return "Verhuurder via sociaal verhuurkantoor";
        }
        case 3: {
            return "Vlaams gewest";
        }
        case 4: {
            return "Lokaal/Regionaal";
        }
        case 5: {
            return "Federaal";
        }
        case 6: {
            return "onderneming";
        }
        case 7: {
            return "VME (vereniging van medeeigneaars)";
        }
        case 8: {
            return "andere";
        }
        default: {
            return "particulier";
        }
    }
}

export class QuoteStatus extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["NotConverted", "Converted"];
    }
}

export function QuoteStatus$reflection() {
    return union_type("Domain.QuoteStatus", [], QuoteStatus, () => [[], []]);
}

export function QuoteStatus_get_list() {
    return ofArray([new QuoteStatus(0), new QuoteStatus(1)]);
}

export class DossierStatus extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["Started", "Cancelled", "Confirmed", "AppointmentBooked", "AppointmentCompleted", "Invoiced", "InvoicePaid", "Completed", "InBehandeling"];
    }
}

export function DossierStatus$reflection() {
    return union_type("Domain.DossierStatus", [], DossierStatus, () => [[], [], [], [], [], [], [], [], []]);
}

export function DossierStatus_get_list() {
    return ofArray([new DossierStatus(0), new DossierStatus(1), new DossierStatus(2), new DossierStatus(3), new DossierStatus(4), new DossierStatus(5), new DossierStatus(6), new DossierStatus(7), new DossierStatus(8)]);
}

export function DossierStatus_isAppointmentAllowed_Z7B6F6316(status) {
    return contains(status, ofArray([new DossierStatus(0), new DossierStatus(8), new DossierStatus(2)]), {
        Equals: equals,
        GetHashCode: safeHash,
    });
}

export class DossierDocumentVersion extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["DocVersion1", "DocVersion2"];
    }
}

export function DossierDocumentVersion$reflection() {
    return union_type("Domain.DossierDocumentVersion", [], DossierDocumentVersion, () => [[], []]);
}

export class TypeOfDiscount extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["NoDiscount", "Flat", "Percentage"];
    }
}

export function TypeOfDiscount$reflection() {
    return union_type("Domain.TypeOfDiscount", [], TypeOfDiscount, () => [[], [["Item", float64_type]], [["Item", float64_type]]]);
}

export class AssignmentDocument extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["Owner", "Partner", "LegalRepresentative", "Syndic", "Other"];
    }
}

export function AssignmentDocument$reflection() {
    return union_type("Domain.AssignmentDocument", [], AssignmentDocument, () => [[], [], [["Item", Email$reflection()]], [["Item", Email$reflection()]], [["Item", Email$reflection()]]]);
}

export function AssignmentDocumentModule_string(assignmentDocument) {
    switch (assignmentDocument.tag) {
        case 1: {
            return "Partner";
        }
        case 2: {
            return "Gevolmachtigde";
        }
        case 3: {
            return "Syndicus";
        }
        case 4: {
            return "Andere";
        }
        default: {
            return "Eigenaar";
        }
    }
}

export class HomeVisitContact extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["Owner", "Partner", "Renter", "ThirdParty", "PickUpKey"];
    }
}

export function HomeVisitContact$reflection() {
    return union_type("Domain.HomeVisitContact", [], HomeVisitContact, () => [[], [], [], [], []]);
}

export function HomeVisitContactModule_string(contact) {
    switch (contact.tag) {
        case 4: {
            return "Sleutel ophalen";
        }
        case 0: {
            return "Eigenaar";
        }
        case 2: {
            return "Huurder";
        }
        case 3: {
            return "Derde partij";
        }
        default: {
            return "Makelaar";
        }
    }
}

export class AsbestosConclusion extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["Safe", "Unsafe"];
    }
}

export function AsbestosConclusion$reflection() {
    return union_type("Domain.AsbestosConclusion", [], AsbestosConclusion, () => [[], []]);
}

export class Dossier extends Record {
    constructor(Id, Code, TypeOfDossier, InspectionLocation, InspectionLocationOther, Client, BuildingDetail, HousingUnit, YearsOfConstruction, YearsOfRenovation, AwareOfAsbestosDescription, IsUserOwnerOfInspectionArea, OwnerStatus, OwnerStatusOther, Address, EmailConfirmations, EmailCustomerCertificate, EmailPartnerCertificate, EmailsToSendCertificate, Status, CustomerId, PartnerId, Owner_FirstName, Owner_LastName, Owner_CompanyName, Owner_CompanyType, Owner_Address, Owner_Email, Owner_PhoneNumber, Owner_IsVME, Owner_IsSocialHousingCompany, Owner_VatNumber, VME_OrganizationName, VME_KboNumber, VME_LastName, VME_FirstName, VME_Address, VME_Email, VME_PhoneNumber, LegalRepresentativeId, OrderConfirmation, AssigmentConfirmation, Certificate, CertificateDate, Conclusion, Lab, Floorplan, CadastralRecords, PropertyOther, OrderConfirmationDigitalSignature, AssignmentConfirmationDigitalSignature, OrderConfirmationPhysicallySigned, AssignmentConfirmationPhysicallySigned, ManualInvoice, ManualInvoice_EmailSent, DocumentVersion, HiddenAsbestos, FloorPlanAvailable, Discount, IsCibDossier, HomeVisitContact, AssignmentDocumentContact, AssignmentDocumentContactEmail, InBehandelingUsername, InspectionLocationBerging, InspectionLocationStaanplaats, InspectionLocationGaragebox, HomeVisitContactName, HomeVisitContactEmail, InBehandelingAdiId, IsPartnerPortalDossier, IsUrgent, CompensationAmount, InvoicePricing, IsRealSmartDossier, QuoteApprovalMeetingDate, NumberOfEntrances, HallwaysPerLevel, PipeIsolationMeters, BoilerRoom, SharedAreaOption1, SharedAreaOption2, SharedAreaOption3, SharedAreaOption4, AssignmentConfirmationSendDate, ResidentialBerging, ResidentialGaragebox, AdditionalGarage, AdditionalGardenbox, AdditionalGreenhouse, ExistingAsbestosAttest, ExistingAsbestosAttestNumbers, ExistingAsbestosAttestSplit, ExistingAsbestosAttestExpired, ExistingAsbestosAttestMaterialChanged, ExistingAsbestosAttestRestrictionLifted, ExistingAsbestosAttestOther, ExistingAsbestosAttestOtherDescription, AsbestInventoryOtherDescription, MultipleOwners, HasTenant, SingleBuildingWithinInspectionArea, RenovationsAfter2000, RenovationsAfter2000Description, BuildingsConstructedAfter2000, BuildingsConstructedAfter2000Details, ReusedMaterialsBefore2001, ReusedMaterialsBefore2001Description, AllowInvoice, Kind, EpcScore, WoonhuisBuildingForm, AssignedAdiId, LinkedDossierId) {
        super();
        this.Id = Id;
        this.Code = Code;
        this.TypeOfDossier = TypeOfDossier;
        this.InspectionLocation = InspectionLocation;
        this.InspectionLocationOther = InspectionLocationOther;
        this.Client = Client;
        this.BuildingDetail = BuildingDetail;
        this.HousingUnit = HousingUnit;
        this.YearsOfConstruction = YearsOfConstruction;
        this.YearsOfRenovation = YearsOfRenovation;
        this.AwareOfAsbestosDescription = AwareOfAsbestosDescription;
        this.IsUserOwnerOfInspectionArea = IsUserOwnerOfInspectionArea;
        this.OwnerStatus = OwnerStatus;
        this.OwnerStatusOther = OwnerStatusOther;
        this.Address = Address;
        this.EmailConfirmations = EmailConfirmations;
        this.EmailCustomerCertificate = EmailCustomerCertificate;
        this.EmailPartnerCertificate = EmailPartnerCertificate;
        this.EmailsToSendCertificate = EmailsToSendCertificate;
        this.Status = Status;
        this.CustomerId = CustomerId;
        this.PartnerId = PartnerId;
        this.Owner_FirstName = Owner_FirstName;
        this.Owner_LastName = Owner_LastName;
        this.Owner_CompanyName = Owner_CompanyName;
        this.Owner_CompanyType = Owner_CompanyType;
        this.Owner_Address = Owner_Address;
        this.Owner_Email = Owner_Email;
        this.Owner_PhoneNumber = Owner_PhoneNumber;
        this.Owner_IsVME = Owner_IsVME;
        this.Owner_IsSocialHousingCompany = Owner_IsSocialHousingCompany;
        this.Owner_VatNumber = Owner_VatNumber;
        this.VME_OrganizationName = VME_OrganizationName;
        this.VME_KboNumber = VME_KboNumber;
        this.VME_LastName = VME_LastName;
        this.VME_FirstName = VME_FirstName;
        this.VME_Address = VME_Address;
        this.VME_Email = VME_Email;
        this.VME_PhoneNumber = VME_PhoneNumber;
        this.LegalRepresentativeId = LegalRepresentativeId;
        this.OrderConfirmation = OrderConfirmation;
        this.AssigmentConfirmation = AssigmentConfirmation;
        this.Certificate = Certificate;
        this.CertificateDate = CertificateDate;
        this.Conclusion = Conclusion;
        this.Lab = Lab;
        this.Floorplan = Floorplan;
        this.CadastralRecords = CadastralRecords;
        this.PropertyOther = PropertyOther;
        this.OrderConfirmationDigitalSignature = OrderConfirmationDigitalSignature;
        this.AssignmentConfirmationDigitalSignature = AssignmentConfirmationDigitalSignature;
        this.OrderConfirmationPhysicallySigned = OrderConfirmationPhysicallySigned;
        this.AssignmentConfirmationPhysicallySigned = AssignmentConfirmationPhysicallySigned;
        this.ManualInvoice = ManualInvoice;
        this.ManualInvoice_EmailSent = ManualInvoice_EmailSent;
        this.DocumentVersion = DocumentVersion;
        this.HiddenAsbestos = HiddenAsbestos;
        this.FloorPlanAvailable = FloorPlanAvailable;
        this.Discount = Discount;
        this.IsCibDossier = IsCibDossier;
        this.HomeVisitContact = HomeVisitContact;
        this.AssignmentDocumentContact = AssignmentDocumentContact;
        this.AssignmentDocumentContactEmail = AssignmentDocumentContactEmail;
        this.InBehandelingUsername = InBehandelingUsername;
        this.InspectionLocationBerging = InspectionLocationBerging;
        this.InspectionLocationStaanplaats = InspectionLocationStaanplaats;
        this.InspectionLocationGaragebox = InspectionLocationGaragebox;
        this.HomeVisitContactName = HomeVisitContactName;
        this.HomeVisitContactEmail = HomeVisitContactEmail;
        this.InBehandelingAdiId = InBehandelingAdiId;
        this.IsPartnerPortalDossier = IsPartnerPortalDossier;
        this.IsUrgent = IsUrgent;
        this.CompensationAmount = CompensationAmount;
        this.InvoicePricing = InvoicePricing;
        this.IsRealSmartDossier = IsRealSmartDossier;
        this.QuoteApprovalMeetingDate = QuoteApprovalMeetingDate;
        this.NumberOfEntrances = NumberOfEntrances;
        this.HallwaysPerLevel = HallwaysPerLevel;
        this.PipeIsolationMeters = PipeIsolationMeters;
        this.BoilerRoom = BoilerRoom;
        this.SharedAreaOption1 = SharedAreaOption1;
        this.SharedAreaOption2 = SharedAreaOption2;
        this.SharedAreaOption3 = SharedAreaOption3;
        this.SharedAreaOption4 = SharedAreaOption4;
        this.AssignmentConfirmationSendDate = AssignmentConfirmationSendDate;
        this.ResidentialBerging = ResidentialBerging;
        this.ResidentialGaragebox = ResidentialGaragebox;
        this.AdditionalGarage = AdditionalGarage;
        this.AdditionalGardenbox = AdditionalGardenbox;
        this.AdditionalGreenhouse = AdditionalGreenhouse;
        this.ExistingAsbestosAttest = ExistingAsbestosAttest;
        this.ExistingAsbestosAttestNumbers = ExistingAsbestosAttestNumbers;
        this.ExistingAsbestosAttestSplit = ExistingAsbestosAttestSplit;
        this.ExistingAsbestosAttestExpired = ExistingAsbestosAttestExpired;
        this.ExistingAsbestosAttestMaterialChanged = ExistingAsbestosAttestMaterialChanged;
        this.ExistingAsbestosAttestRestrictionLifted = ExistingAsbestosAttestRestrictionLifted;
        this.ExistingAsbestosAttestOther = ExistingAsbestosAttestOther;
        this.ExistingAsbestosAttestOtherDescription = ExistingAsbestosAttestOtherDescription;
        this.AsbestInventoryOtherDescription = AsbestInventoryOtherDescription;
        this.MultipleOwners = MultipleOwners;
        this.HasTenant = HasTenant;
        this.SingleBuildingWithinInspectionArea = SingleBuildingWithinInspectionArea;
        this.RenovationsAfter2000 = RenovationsAfter2000;
        this.RenovationsAfter2000Description = RenovationsAfter2000Description;
        this.BuildingsConstructedAfter2000 = BuildingsConstructedAfter2000;
        this.BuildingsConstructedAfter2000Details = BuildingsConstructedAfter2000Details;
        this.ReusedMaterialsBefore2001 = ReusedMaterialsBefore2001;
        this.ReusedMaterialsBefore2001Description = ReusedMaterialsBefore2001Description;
        this.AllowInvoice = AllowInvoice;
        this.Kind = Kind;
        this.EpcScore = EpcScore;
        this.WoonhuisBuildingForm = WoonhuisBuildingForm;
        this.AssignedAdiId = AssignedAdiId;
        this.LinkedDossierId = LinkedDossierId;
    }
}

export function Dossier$reflection() {
    return record_type("Domain.Dossier", [], Dossier, () => [["Id", DossierId$reflection()], ["Code", DossierCode$reflection()], ["TypeOfDossier", TypeOfDossier$reflection()], ["InspectionLocation", InspectionLocation$reflection()], ["InspectionLocationOther", option_type(NonEmptyString$reflection())], ["Client", DossierClient$reflection()], ["BuildingDetail", option_type(NonEmptyString$reflection())], ["HousingUnit", option_type(NonEmptyString$reflection())], ["YearsOfConstruction", option_type(NonEmptyString$reflection())], ["YearsOfRenovation", option_type(NonEmptyString$reflection())], ["AwareOfAsbestosDescription", option_type(NonEmptyString$reflection())], ["IsUserOwnerOfInspectionArea", bool_type], ["OwnerStatus", OwnerStatus$reflection()], ["OwnerStatusOther", option_type(NonEmptyString$reflection())], ["Address", Address$reflection()], ["EmailConfirmations", bool_type], ["EmailCustomerCertificate", bool_type], ["EmailPartnerCertificate", bool_type], ["EmailsToSendCertificate", list_type(Email$reflection())], ["Status", DossierStatus$reflection()], ["CustomerId", CustomerId$reflection()], ["PartnerId", option_type(PartnerId$reflection())], ["Owner_FirstName", option_type(NonEmptyString$reflection())], ["Owner_LastName", option_type(NonEmptyString$reflection())], ["Owner_CompanyName", option_type(NonEmptyString$reflection())], ["Owner_CompanyType", option_type(NonEmptyString$reflection())], ["Owner_Address", Address$reflection()], ["Owner_Email", Email$reflection()], ["Owner_PhoneNumber", option_type(PhoneNumber$reflection())], ["Owner_IsVME", bool_type], ["Owner_IsSocialHousingCompany", bool_type], ["Owner_VatNumber", option_type(VatNumber$reflection())], ["VME_OrganizationName", option_type(NonEmptyString$reflection())], ["VME_KboNumber", option_type(KboNumber$reflection())], ["VME_LastName", option_type(NonEmptyString$reflection())], ["VME_FirstName", option_type(NonEmptyString$reflection())], ["VME_Address", option_type(Address$reflection())], ["VME_Email", option_type(Email$reflection())], ["VME_PhoneNumber", option_type(PhoneNumber$reflection())], ["LegalRepresentativeId", option_type(LegalRepresentativeId$reflection())], ["OrderConfirmation", option_type(FilePath$reflection())], ["AssigmentConfirmation", option_type(FilePath$reflection())], ["Certificate", option_type(FilePath$reflection())], ["CertificateDate", option_type(class_type("System.DateTimeOffset"))], ["Conclusion", option_type(AsbestosConclusion$reflection())], ["Lab", option_type(FilePath$reflection())], ["Floorplan", option_type(FilePath$reflection())], ["CadastralRecords", option_type(FilePath$reflection())], ["PropertyOther", option_type(FilePath$reflection())], ["OrderConfirmationDigitalSignature", option_type(DigitalSignature$reflection())], ["AssignmentConfirmationDigitalSignature", option_type(DigitalSignature$reflection())], ["OrderConfirmationPhysicallySigned", option_type(FilePath$reflection())], ["AssignmentConfirmationPhysicallySigned", option_type(FilePath$reflection())], ["ManualInvoice", bool_type], ["ManualInvoice_EmailSent", bool_type], ["DocumentVersion", DossierDocumentVersion$reflection()], ["HiddenAsbestos", option_type(bool_type)], ["FloorPlanAvailable", option_type(bool_type)], ["Discount", TypeOfDiscount$reflection()], ["IsCibDossier", bool_type], ["HomeVisitContact", HomeVisitContact$reflection()], ["AssignmentDocumentContact", AssignmentDocument$reflection()], ["AssignmentDocumentContactEmail", list_type(Email$reflection())], ["InBehandelingUsername", option_type(string_type)], ["InspectionLocationBerging", option_type(bool_type)], ["InspectionLocationStaanplaats", option_type(bool_type)], ["InspectionLocationGaragebox", option_type(bool_type)], ["HomeVisitContactName", option_type(string_type)], ["HomeVisitContactEmail", option_type(string_type)], ["InBehandelingAdiId", option_type(AdiId$reflection())], ["IsPartnerPortalDossier", bool_type], ["IsUrgent", bool_type], ["CompensationAmount", option_type(Compensation$reflection())], ["InvoicePricing", InvoicePricing$reflection()], ["IsRealSmartDossier", bool_type], ["QuoteApprovalMeetingDate", option_type(class_type("System.DateTimeOffset"))], ["NumberOfEntrances", option_type(NonEmptyString$reflection())], ["HallwaysPerLevel", option_type(NonEmptyString$reflection())], ["PipeIsolationMeters", option_type(NonEmptyString$reflection())], ["BoilerRoom", option_type(bool_type)], ["SharedAreaOption1", option_type(NonEmptyString$reflection())], ["SharedAreaOption2", option_type(NonEmptyString$reflection())], ["SharedAreaOption3", option_type(NonEmptyString$reflection())], ["SharedAreaOption4", option_type(NonEmptyString$reflection())], ["AssignmentConfirmationSendDate", option_type(class_type("System.DateTimeOffset"))], ["ResidentialBerging", option_type(NonEmptyString$reflection())], ["ResidentialGaragebox", option_type(NonEmptyString$reflection())], ["AdditionalGarage", option_type(NonEmptyString$reflection())], ["AdditionalGardenbox", option_type(NonEmptyString$reflection())], ["AdditionalGreenhouse", option_type(NonEmptyString$reflection())], ["ExistingAsbestosAttest", option_type(bool_type)], ["ExistingAsbestosAttestNumbers", option_type(NonEmptyString$reflection())], ["ExistingAsbestosAttestSplit", option_type(bool_type)], ["ExistingAsbestosAttestExpired", option_type(bool_type)], ["ExistingAsbestosAttestMaterialChanged", option_type(bool_type)], ["ExistingAsbestosAttestRestrictionLifted", option_type(bool_type)], ["ExistingAsbestosAttestOther", option_type(bool_type)], ["ExistingAsbestosAttestOtherDescription", option_type(NonEmptyString$reflection())], ["AsbestInventoryOtherDescription", option_type(NonEmptyString$reflection())], ["MultipleOwners", option_type(bool_type)], ["HasTenant", option_type(bool_type)], ["SingleBuildingWithinInspectionArea", option_type(bool_type)], ["RenovationsAfter2000", option_type(bool_type)], ["RenovationsAfter2000Description", option_type(NonEmptyString$reflection())], ["BuildingsConstructedAfter2000", option_type(bool_type)], ["BuildingsConstructedAfter2000Details", option_type(NonEmptyString$reflection())], ["ReusedMaterialsBefore2001", option_type(bool_type)], ["ReusedMaterialsBefore2001Description", option_type(NonEmptyString$reflection())], ["AllowInvoice", bool_type], ["Kind", DossierKind$reflection()], ["EpcScore", option_type(EpcScore$reflection())], ["WoonhuisBuildingForm", option_type(WoonhuisBuildingForm$reflection())], ["AssignedAdiId", option_type(AdiId$reflection())], ["LinkedDossierId", option_type(DossierId$reflection())]]);
}

export class Quote extends Record {
    constructor(Id, Code, TypeOfDossier, InspectionLocation, InspectionLocationOther, Client, BuildingDetail, HousingUnit, YearsOfConstruction, YearsOfRenovation, AwareOfAsbestosDescription, IsUserOwnerOfInspectionArea, OwnerStatus, OwnerStatusOther, Address, EmailConfirmations, EmailCustomerCertificate, EmailPartnerCertificate, EmailsToSendCertificate, Status, CustomerId, PartnerId, Owner_FirstName, Owner_LastName, Owner_CompanyName, Owner_CompanyType, Owner_Address, Owner_Email, Owner_PhoneNumber, Owner_IsVME, Owner_IsSocialHousingCompany, Owner_VatNumber, VME_OrganizationName, VME_KboNumber, LegalRepresentativeId, Conclusion, ManualInvoice, ManualInvoice_EmailSent, HiddenAsbestos, FloorPlanAvailable, Discount, HomeVisitContact, AssignmentDocumentContact, AssignmentDocumentContactEmail, InspectionLocationBerging, InspectionLocationStaanplaats, InspectionLocationGaragebox, HomeVisitContactName, HomeVisitContactEmail, IsPartnerPortalDossier, IsUrgent, CompensationAmount, InvoicePricing, CreatedOn, QuoteDocument, CustomPrice, NumberOfEntrances, HallwaysPerLevel, PipeIsolationMeters, BoilerRoom, DossierCode, SharedAreaOption1, SharedAreaOption2, SharedAreaOption3, SharedAreaOption4) {
        super();
        this.Id = Id;
        this.Code = Code;
        this.TypeOfDossier = TypeOfDossier;
        this.InspectionLocation = InspectionLocation;
        this.InspectionLocationOther = InspectionLocationOther;
        this.Client = Client;
        this.BuildingDetail = BuildingDetail;
        this.HousingUnit = HousingUnit;
        this.YearsOfConstruction = YearsOfConstruction;
        this.YearsOfRenovation = YearsOfRenovation;
        this.AwareOfAsbestosDescription = AwareOfAsbestosDescription;
        this.IsUserOwnerOfInspectionArea = IsUserOwnerOfInspectionArea;
        this.OwnerStatus = OwnerStatus;
        this.OwnerStatusOther = OwnerStatusOther;
        this.Address = Address;
        this.EmailConfirmations = EmailConfirmations;
        this.EmailCustomerCertificate = EmailCustomerCertificate;
        this.EmailPartnerCertificate = EmailPartnerCertificate;
        this.EmailsToSendCertificate = EmailsToSendCertificate;
        this.Status = Status;
        this.CustomerId = CustomerId;
        this.PartnerId = PartnerId;
        this.Owner_FirstName = Owner_FirstName;
        this.Owner_LastName = Owner_LastName;
        this.Owner_CompanyName = Owner_CompanyName;
        this.Owner_CompanyType = Owner_CompanyType;
        this.Owner_Address = Owner_Address;
        this.Owner_Email = Owner_Email;
        this.Owner_PhoneNumber = Owner_PhoneNumber;
        this.Owner_IsVME = Owner_IsVME;
        this.Owner_IsSocialHousingCompany = Owner_IsSocialHousingCompany;
        this.Owner_VatNumber = Owner_VatNumber;
        this.VME_OrganizationName = VME_OrganizationName;
        this.VME_KboNumber = VME_KboNumber;
        this.LegalRepresentativeId = LegalRepresentativeId;
        this.Conclusion = Conclusion;
        this.ManualInvoice = ManualInvoice;
        this.ManualInvoice_EmailSent = ManualInvoice_EmailSent;
        this.HiddenAsbestos = HiddenAsbestos;
        this.FloorPlanAvailable = FloorPlanAvailable;
        this.Discount = Discount;
        this.HomeVisitContact = HomeVisitContact;
        this.AssignmentDocumentContact = AssignmentDocumentContact;
        this.AssignmentDocumentContactEmail = AssignmentDocumentContactEmail;
        this.InspectionLocationBerging = InspectionLocationBerging;
        this.InspectionLocationStaanplaats = InspectionLocationStaanplaats;
        this.InspectionLocationGaragebox = InspectionLocationGaragebox;
        this.HomeVisitContactName = HomeVisitContactName;
        this.HomeVisitContactEmail = HomeVisitContactEmail;
        this.IsPartnerPortalDossier = IsPartnerPortalDossier;
        this.IsUrgent = IsUrgent;
        this.CompensationAmount = CompensationAmount;
        this.InvoicePricing = InvoicePricing;
        this.CreatedOn = CreatedOn;
        this.QuoteDocument = QuoteDocument;
        this.CustomPrice = CustomPrice;
        this.NumberOfEntrances = NumberOfEntrances;
        this.HallwaysPerLevel = HallwaysPerLevel;
        this.PipeIsolationMeters = PipeIsolationMeters;
        this.BoilerRoom = BoilerRoom;
        this.DossierCode = DossierCode;
        this.SharedAreaOption1 = SharedAreaOption1;
        this.SharedAreaOption2 = SharedAreaOption2;
        this.SharedAreaOption3 = SharedAreaOption3;
        this.SharedAreaOption4 = SharedAreaOption4;
    }
}

export function Quote$reflection() {
    return record_type("Domain.Quote", [], Quote, () => [["Id", QuoteId$reflection()], ["Code", QuoteCode$reflection()], ["TypeOfDossier", TypeOfDossier$reflection()], ["InspectionLocation", InspectionLocation$reflection()], ["InspectionLocationOther", option_type(NonEmptyString$reflection())], ["Client", DossierClient$reflection()], ["BuildingDetail", option_type(NonEmptyString$reflection())], ["HousingUnit", option_type(NonEmptyString$reflection())], ["YearsOfConstruction", option_type(NonEmptyString$reflection())], ["YearsOfRenovation", option_type(NonEmptyString$reflection())], ["AwareOfAsbestosDescription", option_type(NonEmptyString$reflection())], ["IsUserOwnerOfInspectionArea", bool_type], ["OwnerStatus", OwnerStatus$reflection()], ["OwnerStatusOther", option_type(NonEmptyString$reflection())], ["Address", Address$reflection()], ["EmailConfirmations", bool_type], ["EmailCustomerCertificate", bool_type], ["EmailPartnerCertificate", bool_type], ["EmailsToSendCertificate", list_type(Email$reflection())], ["Status", QuoteStatus$reflection()], ["CustomerId", CustomerId$reflection()], ["PartnerId", option_type(PartnerId$reflection())], ["Owner_FirstName", option_type(NonEmptyString$reflection())], ["Owner_LastName", option_type(NonEmptyString$reflection())], ["Owner_CompanyName", option_type(NonEmptyString$reflection())], ["Owner_CompanyType", option_type(NonEmptyString$reflection())], ["Owner_Address", Address$reflection()], ["Owner_Email", Email$reflection()], ["Owner_PhoneNumber", option_type(PhoneNumber$reflection())], ["Owner_IsVME", bool_type], ["Owner_IsSocialHousingCompany", bool_type], ["Owner_VatNumber", option_type(VatNumber$reflection())], ["VME_OrganizationName", option_type(NonEmptyString$reflection())], ["VME_KboNumber", option_type(KboNumber$reflection())], ["LegalRepresentativeId", option_type(LegalRepresentativeId$reflection())], ["Conclusion", option_type(AsbestosConclusion$reflection())], ["ManualInvoice", bool_type], ["ManualInvoice_EmailSent", bool_type], ["HiddenAsbestos", option_type(bool_type)], ["FloorPlanAvailable", option_type(bool_type)], ["Discount", TypeOfDiscount$reflection()], ["HomeVisitContact", option_type(HomeVisitContact$reflection())], ["AssignmentDocumentContact", AssignmentDocument$reflection()], ["AssignmentDocumentContactEmail", list_type(Email$reflection())], ["InspectionLocationBerging", option_type(bool_type)], ["InspectionLocationStaanplaats", option_type(bool_type)], ["InspectionLocationGaragebox", option_type(bool_type)], ["HomeVisitContactName", option_type(string_type)], ["HomeVisitContactEmail", option_type(string_type)], ["IsPartnerPortalDossier", bool_type], ["IsUrgent", bool_type], ["CompensationAmount", option_type(Compensation$reflection())], ["InvoicePricing", InvoicePricing$reflection()], ["CreatedOn", class_type("System.DateTimeOffset")], ["QuoteDocument", option_type(FilePath$reflection())], ["CustomPrice", option_type(Decimal$reflection())], ["NumberOfEntrances", option_type(NonEmptyString$reflection())], ["HallwaysPerLevel", option_type(NonEmptyString$reflection())], ["PipeIsolationMeters", option_type(NonEmptyString$reflection())], ["BoilerRoom", option_type(bool_type)], ["DossierCode", option_type(DossierCode$reflection())], ["SharedAreaOption1", option_type(NonEmptyString$reflection())], ["SharedAreaOption2", option_type(NonEmptyString$reflection())], ["SharedAreaOption3", option_type(NonEmptyString$reflection())], ["SharedAreaOption4", option_type(NonEmptyString$reflection())]]);
}

export class TypeOfCorporation extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["NV", "BV", "CV", "VOF", "SingleProprietor"];
    }
}

export function TypeOfCorporation$reflection() {
    return union_type("Domain.TypeOfCorporation", [], TypeOfCorporation, () => [[], [], [], [], []]);
}

export function TypeOfCorporation_ToString_Z4775BF2C(value) {
    switch (value.tag) {
        case 1: {
            return "BV";
        }
        case 2: {
            return "CV";
        }
        case 3: {
            return "VOF";
        }
        case 4: {
            return "Eenmanszaak";
        }
        default: {
            return "NV";
        }
    }
}

export class CompanyInformation extends Record {
    constructor(CompanyId, Name, TypeOfCorporation, PhoneNumber, Email) {
        super();
        this.CompanyId = CompanyId;
        this.Name = Name;
        this.TypeOfCorporation = TypeOfCorporation;
        this.PhoneNumber = PhoneNumber;
        this.Email = Email;
    }
}

export function CompanyInformation$reflection() {
    return record_type("Domain.CompanyInformation", [], CompanyInformation, () => [["CompanyId", CompanyId$reflection()], ["Name", NonEmptyString$reflection()], ["TypeOfCorporation", TypeOfCorporation$reflection()], ["PhoneNumber", PhoneNumber$reflection()], ["Email", Email$reflection()]]);
}

export class CompanyFormat extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["SoleProprietor", "Corporation"];
    }
}

export function CompanyFormat$reflection() {
    return union_type("Domain.CompanyFormat", [], CompanyFormat, () => [[], [["Item", CompanyInformation$reflection()]]]);
}

export class Company extends Record {
    constructor(CompanyId, VatNumber, BankAccount, TermOfPayment, VatLiable, Address, CompanyFormat) {
        super();
        this.CompanyId = CompanyId;
        this.VatNumber = VatNumber;
        this.BankAccount = BankAccount;
        this.TermOfPayment = (TermOfPayment | 0);
        this.VatLiable = VatLiable;
        this.Address = Address;
        this.CompanyFormat = CompanyFormat;
    }
}

export function Company$reflection() {
    return record_type("Domain.Company", [], Company, () => [["CompanyId", CompanyId$reflection()], ["VatNumber", VatNumber$reflection()], ["BankAccount", BankAccount$reflection()], ["TermOfPayment", int32_type], ["VatLiable", bool_type], ["Address", Address$reflection()], ["CompanyFormat", CompanyFormat$reflection()]]);
}

export class AdiRole extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["Junior", "Senior", "Master", "Partner"];
    }
}

export function AdiRole$reflection() {
    return union_type("Domain.AdiRole", [], AdiRole, () => [[], [], [], []]);
}

export function AdiRoleModule_string(role) {
    switch (role.tag) {
        case 1: {
            return "Senior";
        }
        case 2: {
            return "Master";
        }
        case 3: {
            return "Partner";
        }
        default: {
            return "Junior";
        }
    }
}

export function AdiRoleModule_value(role) {
    if (role != null) {
        if (role.tag === 1) {
            return 2;
        }
        else if (role.tag === 2) {
            return 3;
        }
        else if (role.tag === 3) {
            return 4;
        }
        else {
            return 1;
        }
    }
    else {
        return 0;
    }
}

export class InspectorType extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["Adi", "EpcInspector"];
    }
}

export function InspectorType$reflection() {
    return union_type("Domain.InspectorType", [], InspectorType, () => [[], []]);
}

export class Adi extends Record {
    constructor(Id, LastName, FirstName, Address, Email, PhoneNumber, NationalInsuranceNumber, PersonIdOvam, EmailAsbestConsulting, AdiCompany, TrainingCertification, IbexExamCertification, PersonalCertification, DiplomaTraining, ExtraEducation, Regions, Role, IsActive, InspectorType) {
        super();
        this.Id = Id;
        this.LastName = LastName;
        this.FirstName = FirstName;
        this.Address = Address;
        this.Email = Email;
        this.PhoneNumber = PhoneNumber;
        this.NationalInsuranceNumber = NationalInsuranceNumber;
        this.PersonIdOvam = PersonIdOvam;
        this.EmailAsbestConsulting = EmailAsbestConsulting;
        this.AdiCompany = AdiCompany;
        this.TrainingCertification = TrainingCertification;
        this.IbexExamCertification = IbexExamCertification;
        this.PersonalCertification = PersonalCertification;
        this.DiplomaTraining = DiplomaTraining;
        this.ExtraEducation = ExtraEducation;
        this.Regions = Regions;
        this.Role = Role;
        this.IsActive = IsActive;
        this.InspectorType = InspectorType;
    }
}

export function Adi$reflection() {
    return record_type("Domain.Adi", [], Adi, () => [["Id", AdiId$reflection()], ["LastName", NonEmptyString$reflection()], ["FirstName", NonEmptyString$reflection()], ["Address", Address$reflection()], ["Email", Email$reflection()], ["PhoneNumber", PhoneNumber$reflection()], ["NationalInsuranceNumber", NationalInsuranceNumber$reflection()], ["PersonIdOvam", option_type(PersonIdOvam$reflection())], ["EmailAsbestConsulting", Email$reflection()], ["AdiCompany", Company$reflection()], ["TrainingCertification", option_type(FilePath$reflection())], ["IbexExamCertification", option_type(FilePath$reflection())], ["PersonalCertification", option_type(FilePath$reflection())], ["DiplomaTraining", option_type(FilePath$reflection())], ["ExtraEducation", option_type(FilePath$reflection())], ["Regions", class_type("Microsoft.FSharp.Collections.FSharpSet`1", [Region$reflection()])], ["Role", option_type(AdiRole$reflection())], ["IsActive", bool_type], ["InspectorType", InspectorType$reflection()]]);
}

export class PreferredAdi extends Record {
    constructor(NormalAdis, PreferredAdis) {
        super();
        this.NormalAdis = NormalAdis;
        this.PreferredAdis = PreferredAdis;
    }
}

export function PreferredAdi$reflection() {
    return record_type("Domain.PreferredAdi", [], PreferredAdi, () => [["NormalAdis", list_type(Adi$reflection())], ["PreferredAdis", list_type(Adi$reflection())]]);
}

export function PreferredAdi__AdisWithMinimumRole_Z7F80284D(this$, minimumRole) {
    return sortByDescending((adi_2) => AdiRoleModule_value(adi_2.Role), filter((adi_1) => (AdiRoleModule_value(adi_1.Role) >= AdiRoleModule_value(minimumRole)), filter((adi) => (!contains(adi, this$.PreferredAdis, {
        Equals: equals,
        GetHashCode: safeHash,
    })), this$.NormalAdis)), {
        Compare: comparePrimitives,
    });
}

export class File extends Record {
    constructor(Id, FileName, UploadedAt) {
        super();
        this.Id = Id;
        this.FileName = FileName;
        this.UploadedAt = UploadedAt;
    }
}

export function File$reflection() {
    return record_type("Domain.File", [], File, () => [["Id", FileId$reflection()], ["FileName", FilePath$reflection()], ["UploadedAt", class_type("System.DateTimeOffset")]]);
}

export class CustomerPerson extends Record {
    constructor(Id, Code, LastName, FirstName, Address, Email, PhoneNumber, InvoicingId, TenantPartnerId, IsCibCustomer) {
        super();
        this.Id = Id;
        this.Code = Code;
        this.LastName = LastName;
        this.FirstName = FirstName;
        this.Address = Address;
        this.Email = Email;
        this.PhoneNumber = PhoneNumber;
        this.InvoicingId = InvoicingId;
        this.TenantPartnerId = TenantPartnerId;
        this.IsCibCustomer = IsCibCustomer;
    }
}

export function CustomerPerson$reflection() {
    return record_type("Domain.CustomerPerson", [], CustomerPerson, () => [["Id", CustomerId$reflection()], ["Code", CustomerCode$reflection()], ["LastName", NonEmptyString$reflection()], ["FirstName", NonEmptyString$reflection()], ["Address", Address$reflection()], ["Email", Email$reflection()], ["PhoneNumber", option_type(PhoneNumber$reflection())], ["InvoicingId", option_type(InvoicingId$reflection())], ["TenantPartnerId", option_type(PartnerId$reflection())], ["IsCibCustomer", bool_type]]);
}

export class CustomerCompany extends Record {
    constructor(Id, Code, CompanyName, CompanyType, Address, Email, PhoneNumber, VatNumber, InvoicingId, TenantPartnerId, IsCibCustomer, IsVME, IsSocialHousingCompany, LastName, FirstName) {
        super();
        this.Id = Id;
        this.Code = Code;
        this.CompanyName = CompanyName;
        this.CompanyType = CompanyType;
        this.Address = Address;
        this.Email = Email;
        this.PhoneNumber = PhoneNumber;
        this.VatNumber = VatNumber;
        this.InvoicingId = InvoicingId;
        this.TenantPartnerId = TenantPartnerId;
        this.IsCibCustomer = IsCibCustomer;
        this.IsVME = IsVME;
        this.IsSocialHousingCompany = IsSocialHousingCompany;
        this.LastName = LastName;
        this.FirstName = FirstName;
    }
}

export function CustomerCompany$reflection() {
    return record_type("Domain.CustomerCompany", [], CustomerCompany, () => [["Id", CustomerId$reflection()], ["Code", CustomerCode$reflection()], ["CompanyName", NonEmptyString$reflection()], ["CompanyType", option_type(NonEmptyString$reflection())], ["Address", Address$reflection()], ["Email", Email$reflection()], ["PhoneNumber", option_type(PhoneNumber$reflection())], ["VatNumber", VatNumber$reflection()], ["InvoicingId", option_type(InvoicingId$reflection())], ["TenantPartnerId", option_type(PartnerId$reflection())], ["IsCibCustomer", bool_type], ["IsVME", bool_type], ["IsSocialHousingCompany", bool_type], ["LastName", option_type(NonEmptyString$reflection())], ["FirstName", option_type(NonEmptyString$reflection())]]);
}

export class Customer2 extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["Person", "Company"];
    }
}

export function Customer2$reflection() {
    return union_type("Domain.Customer2", [], Customer2, () => [[["Item", CustomerPerson$reflection()]], [["Item", CustomerCompany$reflection()]]]);
}

export function Customer2__get_Id(this$) {
    if (this$.tag === 0) {
        return this$.fields[0].Id;
    }
    else {
        return this$.fields[0].Id;
    }
}

export function Customer2__get_PhoneNumber(this$) {
    if (this$.tag === 0) {
        return this$.fields[0].PhoneNumber;
    }
    else {
        return this$.fields[0].PhoneNumber;
    }
}

export function Customer2__get_Code(this$) {
    if (this$.tag === 1) {
        return this$.fields[0].Code;
    }
    else {
        return this$.fields[0].Code;
    }
}

export function Customer2__get_Address(this$) {
    if (this$.tag === 1) {
        return this$.fields[0].Address;
    }
    else {
        return this$.fields[0].Address;
    }
}

export function Customer2__get_Email(this$) {
    if (this$.tag === 1) {
        return this$.fields[0].Email;
    }
    else {
        return this$.fields[0].Email;
    }
}

export function Customer2__get_CustomerOrCompanyName(this$) {
    if (this$.tag === 1) {
        return `${this$.fields[0].CompanyName.Value}`;
    }
    else {
        const customer = this$.fields[0];
        return `${customer.FirstName.Value} ${customer.LastName.Value}`;
    }
}

export function Customer2__get_InvoicingId(this$) {
    if (this$.tag === 1) {
        return this$.fields[0].InvoicingId;
    }
    else {
        return this$.fields[0].InvoicingId;
    }
}

export class Customer extends Record {
    constructor(Id, Code, LastName, FirstName, CompanyName, Address, Email, PhoneNumber, VatNumber, KboNumber, InvoicingId, TenantPartnerId, IsCibCustomer, IsVME, IsSocialHousingCompany) {
        super();
        this.Id = Id;
        this.Code = Code;
        this.LastName = LastName;
        this.FirstName = FirstName;
        this.CompanyName = CompanyName;
        this.Address = Address;
        this.Email = Email;
        this.PhoneNumber = PhoneNumber;
        this.VatNumber = VatNumber;
        this.KboNumber = KboNumber;
        this.InvoicingId = InvoicingId;
        this.TenantPartnerId = TenantPartnerId;
        this.IsCibCustomer = IsCibCustomer;
        this.IsVME = IsVME;
        this.IsSocialHousingCompany = IsSocialHousingCompany;
    }
}

export function Customer$reflection() {
    return record_type("Domain.Customer", [], Customer, () => [["Id", CustomerId$reflection()], ["Code", CustomerCode$reflection()], ["LastName", option_type(NonEmptyString$reflection())], ["FirstName", option_type(NonEmptyString$reflection())], ["CompanyName", option_type(NonEmptyString$reflection())], ["Address", Address$reflection()], ["Email", Email$reflection()], ["PhoneNumber", option_type(PhoneNumber$reflection())], ["VatNumber", option_type(VatNumber$reflection())], ["KboNumber", option_type(KboNumber$reflection())], ["InvoicingId", option_type(InvoicingId$reflection())], ["TenantPartnerId", option_type(PartnerId$reflection())], ["IsCibCustomer", bool_type], ["IsVME", bool_type], ["IsSocialHousingCompany", bool_type]]);
}

export class LegalRepresentative extends Record {
    constructor(Id, LastName, FirstName, Address, Email, PhoneNumber) {
        super();
        this.Id = Id;
        this.LastName = LastName;
        this.FirstName = FirstName;
        this.Address = Address;
        this.Email = Email;
        this.PhoneNumber = PhoneNumber;
    }
}

export function LegalRepresentative$reflection() {
    return record_type("Domain.LegalRepresentative", [], LegalRepresentative, () => [["Id", LegalRepresentativeId$reflection()], ["LastName", NonEmptyString$reflection()], ["FirstName", NonEmptyString$reflection()], ["Address", Address$reflection()], ["Email", option_type(Email$reflection())], ["PhoneNumber", option_type(PhoneNumber$reflection())]]);
}

export class InvoiceStatus extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["Pending", "Open", "Overdue", "Paid", "Overpaid"];
    }
}

export function InvoiceStatus$reflection() {
    return union_type("Domain.InvoiceStatus", [], InvoiceStatus, () => [[], [], [], [], []]);
}

export class InvoiceLine extends Record {
    constructor(InvoiceLineId, ProductType, Quantity, ReferenceNumber, Price) {
        super();
        this.InvoiceLineId = InvoiceLineId;
        this.ProductType = ProductType;
        this.Quantity = Quantity;
        this.ReferenceNumber = ReferenceNumber;
        this.Price = Price;
    }
}

export function InvoiceLine$reflection() {
    return record_type("Domain.InvoiceLine", [], InvoiceLine, () => [["InvoiceLineId", InvoiceLineId$reflection()], ["ProductType", ProductType$reflection()], ["Quantity", class_type("System.Decimal")], ["ReferenceNumber", ProductReferenceNumber$reflection()], ["Price", option_type(class_type("System.Decimal"))]]);
}

export class Invoice extends Record {
    constructor(Id, DossierId, ExternalId, Status, CreatedOn, Lines) {
        super();
        this.Id = Id;
        this.DossierId = DossierId;
        this.ExternalId = ExternalId;
        this.Status = Status;
        this.CreatedOn = CreatedOn;
        this.Lines = Lines;
    }
}

export function Invoice$reflection() {
    return record_type("Domain.Invoice", [], Invoice, () => [["Id", InvoiceId$reflection()], ["DossierId", DossierId$reflection()], ["ExternalId", option_type(string_type)], ["Status", InvoiceStatus$reflection()], ["CreatedOn", class_type("System.DateTimeOffset")], ["Lines", list_type(InvoiceLine$reflection())]]);
}

export class AvailabilityCalendarEvent extends Record {
    constructor(Id, AdiId, StartTime, EndTime) {
        super();
        this.Id = Id;
        this.AdiId = AdiId;
        this.StartTime = StartTime;
        this.EndTime = EndTime;
    }
}

export function AvailabilityCalendarEvent$reflection() {
    return record_type("Domain.AvailabilityCalendarEvent", [], AvailabilityCalendarEvent, () => [["Id", AvailabilityCalendarEventId$reflection()], ["AdiId", AdiId$reflection()], ["StartTime", class_type("System.DateTimeOffset")], ["EndTime", class_type("System.DateTimeOffset")]]);
}

export class QuoteDocument extends Record {
    constructor(Id, QuoteId, DocumentPath, DocumentType$, FileName, FileType) {
        super();
        this.Id = Id;
        this.QuoteId = QuoteId;
        this.DocumentPath = DocumentPath;
        this.DocumentType = DocumentType$;
        this.FileName = FileName;
        this.FileType = FileType;
    }
}

export function QuoteDocument$reflection() {
    return record_type("Domain.QuoteDocument", [], QuoteDocument, () => [["Id", QuoteDocumentId$reflection()], ["QuoteId", option_type(QuoteId$reflection())], ["DocumentPath", FilePath$reflection()], ["DocumentType", QuoteDocumentType$reflection()], ["FileName", string_type], ["FileType", QuoteFileType$reflection()]]);
}

export class Partner extends Record {
    constructor(Id, Code, CompanyName, CompanyType, ContactFirstName, ContactLastName, Address, Email, PhoneNumber, VatNumber, TenantPartnerCustomerId, IsCibPartner, IsVME, IsSocialHousingCompany, MinimumRole, CompensationAmount, CompensationAmountEpc, PartnerType, CommercialName) {
        super();
        this.Id = Id;
        this.Code = Code;
        this.CompanyName = CompanyName;
        this.CompanyType = CompanyType;
        this.ContactFirstName = ContactFirstName;
        this.ContactLastName = ContactLastName;
        this.Address = Address;
        this.Email = Email;
        this.PhoneNumber = PhoneNumber;
        this.VatNumber = VatNumber;
        this.TenantPartnerCustomerId = TenantPartnerCustomerId;
        this.IsCibPartner = IsCibPartner;
        this.IsVME = IsVME;
        this.IsSocialHousingCompany = IsSocialHousingCompany;
        this.MinimumRole = MinimumRole;
        this.CompensationAmount = CompensationAmount;
        this.CompensationAmountEpc = CompensationAmountEpc;
        this.PartnerType = PartnerType;
        this.CommercialName = CommercialName;
    }
}

export function Partner$reflection() {
    return record_type("Domain.Partner", [], Partner, () => [["Id", PartnerId$reflection()], ["Code", PartnerCode$reflection()], ["CompanyName", NonEmptyString$reflection()], ["CompanyType", option_type(NonEmptyString$reflection())], ["ContactFirstName", option_type(NonEmptyString$reflection())], ["ContactLastName", option_type(NonEmptyString$reflection())], ["Address", Address$reflection()], ["Email", Email$reflection()], ["PhoneNumber", PhoneNumber$reflection()], ["VatNumber", option_type(VatNumber$reflection())], ["TenantPartnerCustomerId", option_type(CustomerId$reflection())], ["IsCibPartner", bool_type], ["IsVME", bool_type], ["IsSocialHousingCompany", bool_type], ["MinimumRole", option_type(AdiRole$reflection())], ["CompensationAmount", option_type(Compensation$reflection())], ["CompensationAmountEpc", option_type(Compensation$reflection())], ["PartnerType", PartnerType$reflection()], ["CommercialName", option_type(NonEmptyString$reflection())]]);
}

export function Partner__get_Firstname(this$) {
    const matchValue = this$.ContactFirstName;
    if (matchValue != null) {
        const firstName = matchValue;
        return `${firstName.Value}`;
    }
    else {
        return "";
    }
}

export function Partner__get_LastName(this$) {
    const matchValue = this$.ContactLastName;
    if (matchValue != null) {
        const lastName = matchValue;
        return `${lastName.Value}`;
    }
    else {
        return "";
    }
}

export class PartnerWithPreferredAdis extends Record {
    constructor(Partner, PartnerAdis) {
        super();
        this.Partner = Partner;
        this.PartnerAdis = PartnerAdis;
    }
}

export function PartnerWithPreferredAdis$reflection() {
    return record_type("Domain.PartnerWithPreferredAdis", [], PartnerWithPreferredAdis, () => [["Partner", Partner$reflection()], ["PartnerAdis", list_type(Adi$reflection())]]);
}

export class TypeOfCorporationData extends Record {
    constructor(Value) {
        super();
        this.Value = Value;
    }
}

export function TypeOfCorporationData$reflection() {
    return record_type("Domain.TypeOfCorporationData", [], TypeOfCorporationData, () => [["Value", TypeOfCorporation$reflection()]]);
}

export function TypeOfCorporationData_Create_2CC5FFA1(value) {
    return map(TypeOfCorporationData___UnsafeCreate_Z4775BF2C, value);
}

export function TypeOfCorporationData___UnsafeCreate_Z4775BF2C(value) {
    return new TypeOfCorporationData(value);
}

export function TypeOfCorporationData___UnsafeUnwrap_Z7D7D171C(x) {
    return x.Value;
}

export class TypeOfDossierData extends Record {
    constructor(Value) {
        super();
        this.Value = Value;
    }
}

export function TypeOfDossierData$reflection() {
    return record_type("Domain.TypeOfDossierData", [], TypeOfDossierData, () => [["Value", TypeOfDossier$reflection()]]);
}

export function TypeOfDossierData_Create_Z6219B46(value) {
    return map(TypeOfDossierData___UnsafeCreate_Z1D754B91, value);
}

export function TypeOfDossierData___UnsafeCreate_Z1D754B91(value) {
    return new TypeOfDossierData(value);
}

export function TypeOfDossierData___UnsafeUnwrap_Z27899461(x) {
    return x.Value;
}

export class AsbestInventoryData extends Record {
    constructor(Value) {
        super();
        this.Value = Value;
    }
}

export function AsbestInventoryData$reflection() {
    return record_type("Domain.AsbestInventoryData", [], AsbestInventoryData, () => [["Value", AsbestInventory$reflection()]]);
}

export function AsbestInventoryData_Create_7B10C0C6(value) {
    return map(AsbestInventoryData___UnsafeCreate_Z54AF902D, value);
}

export function AsbestInventoryData___UnsafeCreate_Z54AF902D(value) {
    return new AsbestInventoryData(value);
}

export function AsbestInventoryData___UnsafeUnwrap_Z4501305D(x) {
    return x.Value;
}

export class SelectOptionData$1 extends Record {
    constructor(Value) {
        super();
        this.Value = Value;
    }
}

export function SelectOptionData$1$reflection(gen0) {
    return record_type("Domain.SelectOptionData`1", [gen0], SelectOptionData$1, () => [["Value", gen0]]);
}

export function SelectOptionData$1_Create_Z510A3DC0(value) {
    return map(SelectOptionData$1___UnsafeCreate_2B595, value);
}

export function SelectOptionData$1___UnsafeCreate_2B595(value) {
    return new SelectOptionData$1(value);
}

export function SelectOptionData$1___UnsafeUnwrap_3C423657(x) {
    return x.Value;
}

export class AppointmentListType extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["Today", "AllMyAppointments", "ToChargeSamples", "AllAppointments"];
    }
}

export function AppointmentListType$reflection() {
    return union_type("Domain.AppointmentListType", [], AppointmentListType, () => [[], [], [], []]);
}

export class DigitalSignaturePartnerInfoConfigAddress extends Record {
    constructor(Street, Number$, Bus, PostalCode, City) {
        super();
        this.Street = Street;
        this.Number = Number$;
        this.Bus = Bus;
        this.PostalCode = PostalCode;
        this.City = City;
    }
}

export function DigitalSignaturePartnerInfoConfigAddress$reflection() {
    return record_type("Domain.DigitalSignaturePartnerInfoConfigAddress", [], DigitalSignaturePartnerInfoConfigAddress, () => [["Street", string_type], ["Number", string_type], ["Bus", string_type], ["PostalCode", string_type], ["City", string_type]]);
}

export class DigitalSignaturePartnerInfo extends Record {
    constructor(PartnerId, LastName, FirstName, Address, Email, PhoneNumber, HiddenAsbestos, FloorplanAvailable) {
        super();
        this.PartnerId = (PartnerId | 0);
        this.LastName = LastName;
        this.FirstName = FirstName;
        this.Address = Address;
        this.Email = Email;
        this.PhoneNumber = PhoneNumber;
        this.HiddenAsbestos = HiddenAsbestos;
        this.FloorplanAvailable = FloorplanAvailable;
    }
}

export function DigitalSignaturePartnerInfo$reflection() {
    return record_type("Domain.DigitalSignaturePartnerInfo", [], DigitalSignaturePartnerInfo, () => [["PartnerId", int32_type], ["LastName", string_type], ["FirstName", string_type], ["Address", DigitalSignaturePartnerInfoConfigAddress$reflection()], ["Email", string_type], ["PhoneNumber", string_type], ["HiddenAsbestos", bool_type], ["FloorplanAvailable", bool_type]]);
}

export class DigitalSignatureStatus extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["Signed", "UnSigned", "SignatureExpired", "InvalidSignature"];
    }
}

export function DigitalSignatureStatus$reflection() {
    return union_type("Domain.DigitalSignatureStatus", [], DigitalSignatureStatus, () => [[["Item", tuple_type(FilePath$reflection(), DigitalSignature$reflection())]], [["Item", tuple_type(FilePath$reflection(), DigitalSignature$reflection(), option_type(DigitalSignaturePartnerInfo$reflection()))]], [["Item", string_type]], []]);
}

export class DossierEvent extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["DossierCreated", "DossierCreatedFromQuote", "DossierUpdated", "AssignmentDocumentRegenerated", "DossierCancelled"];
    }
}

export function DossierEvent$reflection() {
    return union_type("Domain.DossierEvent", [], DossierEvent, () => [[], [], [], [], []]);
}

export class DossierEventLog extends Record {
    constructor(Id, DossierId, Name, Event$, CreatedOn, FinalizedCertificateDate) {
        super();
        this.Id = Id;
        this.DossierId = DossierId;
        this.Name = Name;
        this.Event = Event$;
        this.CreatedOn = CreatedOn;
        this.FinalizedCertificateDate = FinalizedCertificateDate;
    }
}

export function DossierEventLog$reflection() {
    return record_type("Domain.DossierEventLog", [], DossierEventLog, () => [["Id", DossierEventLogId$reflection()], ["DossierId", DossierId$reflection()], ["Name", NonEmptyString$reflection()], ["Event", DossierEvent$reflection()], ["CreatedOn", class_type("System.DateTimeOffset")], ["FinalizedCertificateDate", option_type(class_type("System.DateTimeOffset"))]]);
}

export class CreateCustomerResult extends Record {
    constructor(Id, Code) {
        super();
        this.Id = Id;
        this.Code = Code;
    }
}

export function CreateCustomerResult$reflection() {
    return record_type("Domain.CreateCustomerResult", [], CreateCustomerResult, () => [["Id", CustomerId$reflection()], ["Code", CustomerCode$reflection()]]);
}

export class CreateDossierResult extends Record {
    constructor(Id, Code) {
        super();
        this.Id = Id;
        this.Code = Code;
    }
}

export function CreateDossierResult$reflection() {
    return record_type("Domain.CreateDossierResult", [], CreateDossierResult, () => [["Id", DossierId$reflection()], ["Code", DossierCode$reflection()]]);
}

export class CreateQuoteResult extends Record {
    constructor(Id, Code) {
        super();
        this.Id = Id;
        this.Code = Code;
    }
}

export function CreateQuoteResult$reflection() {
    return record_type("Domain.CreateQuoteResult", [], CreateQuoteResult, () => [["Id", QuoteId$reflection()], ["Code", DossierCode$reflection()]]);
}

export class EmailVerificationResponse extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["Valid", "Invalid"];
    }
}

export function EmailVerificationResponse$reflection() {
    return union_type("Domain.EmailVerificationResponse", [], EmailVerificationResponse, () => [[["Item", option_type(string_type)]], [["Item", string_type]]]);
}

export class CustomerPersonData extends Record {
    constructor(LastName, FirstName, Address, Email, PhoneNumber, IsCibCustomer) {
        super();
        this.LastName = LastName;
        this.FirstName = FirstName;
        this.Address = Address;
        this.Email = Email;
        this.PhoneNumber = PhoneNumber;
        this.IsCibCustomer = IsCibCustomer;
    }
}

export function CustomerPersonData$reflection() {
    return record_type("Domain.CustomerPersonData", [], CustomerPersonData, () => [["LastName", NonEmptyString$reflection()], ["FirstName", NonEmptyString$reflection()], ["Address", Address$reflection()], ["Email", Email$reflection()], ["PhoneNumber", option_type(PhoneNumber$reflection())], ["IsCibCustomer", bool_type]]);
}

export class CustomerCompanyData extends Record {
    constructor(CompanyName, CompanyType, Address, Email, PhoneNumber, VatNumber, IsCibCustomer, IsVME, IsSocialHousingCompany, LastName, FirstName) {
        super();
        this.CompanyName = CompanyName;
        this.CompanyType = CompanyType;
        this.Address = Address;
        this.Email = Email;
        this.PhoneNumber = PhoneNumber;
        this.VatNumber = VatNumber;
        this.IsCibCustomer = IsCibCustomer;
        this.IsVME = IsVME;
        this.IsSocialHousingCompany = IsSocialHousingCompany;
        this.LastName = LastName;
        this.FirstName = FirstName;
    }
}

export function CustomerCompanyData$reflection() {
    return record_type("Domain.CustomerCompanyData", [], CustomerCompanyData, () => [["CompanyName", NonEmptyString$reflection()], ["CompanyType", option_type(NonEmptyString$reflection())], ["Address", Address$reflection()], ["Email", Email$reflection()], ["PhoneNumber", option_type(PhoneNumber$reflection())], ["VatNumber", VatNumber$reflection()], ["IsCibCustomer", bool_type], ["IsVME", bool_type], ["IsSocialHousingCompany", bool_type], ["LastName", option_type(NonEmptyString$reflection())], ["FirstName", option_type(NonEmptyString$reflection())]]);
}

export class CustomerData2 extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["Person", "Company"];
    }
}

export function CustomerData2$reflection() {
    return union_type("Domain.CustomerData2", [], CustomerData2, () => [[["Item", CustomerPersonData$reflection()]], [["Item", CustomerCompanyData$reflection()]]]);
}

export function CustomerData2__get_CustomerOrCompanyName(this$) {
    if (this$.tag === 1) {
        return `${this$.fields[0].CompanyName.Value}`;
    }
    else {
        const person = this$.fields[0];
        return `${person.FirstName.Value} ${person.LastName.Value}`;
    }
}

export function CustomerData2__get_PhoneNumber(this$) {
    if (this$.tag === 0) {
        return this$.fields[0].PhoneNumber;
    }
    else {
        return this$.fields[0].PhoneNumber;
    }
}

export function CustomerData2__get_Address(this$) {
    if (this$.tag === 1) {
        return this$.fields[0].Address;
    }
    else {
        return this$.fields[0].Address;
    }
}

export function CustomerData2__get_Email(this$) {
    if (this$.tag === 1) {
        return this$.fields[0].Email;
    }
    else {
        return this$.fields[0].Email;
    }
}

export class DossierCustomerSelection extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["ExistingCustomer", "NewCustomer"];
    }
}

export function DossierCustomerSelection$reflection() {
    return union_type("Domain.DossierCustomerSelection", [], DossierCustomerSelection, () => [[["Item", Customer2$reflection()]], [["Item", CustomerData2$reflection()]]]);
}

export class DossierCompany extends Record {
    constructor(CompanyName, Email, PhoneNumber, VatNumber, KboNumber) {
        super();
        this.CompanyName = CompanyName;
        this.Email = Email;
        this.PhoneNumber = PhoneNumber;
        this.VatNumber = VatNumber;
        this.KboNumber = KboNumber;
    }
}

export function DossierCompany$reflection() {
    return record_type("Domain.DossierCompany", [], DossierCompany, () => [["CompanyName", NonEmptyString$reflection()], ["Email", Email$reflection()], ["PhoneNumber", option_type(PhoneNumber$reflection())], ["VatNumber", VatNumber$reflection()], ["KboNumber", option_type(KboNumber$reflection())]]);
}

export class DossierCustomer extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["Partner", "Customer", "NotSelected"];
    }
}

export function DossierCustomer$reflection() {
    return union_type("Domain.DossierCustomer", [], DossierCustomer, () => [[["Item", Customer2$reflection()]], [["Item", DossierCustomerSelection$reflection()]], []]);
}

export class TypeOfCustomer extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["Person", "Company"];
    }
}

export function TypeOfCustomer$reflection() {
    return union_type("Domain.TypeOfCustomer", [], TypeOfCustomer, () => [[], []]);
}

export function TypeOfCustomerModule_string(typeOfCustomer) {
    if (typeOfCustomer.tag === 1) {
        return "Rechtspersoon";
    }
    else {
        return "Natuurlijk persoon";
    }
}

export class ContactOwner extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["Person", "Company"];
    }
}

export function ContactOwner$reflection() {
    return union_type("Domain.ContactOwner", [], ContactOwner, () => [[], []]);
}

export function ContactOwnerModule_string(owner) {
    if (owner.tag === 1) {
        return "Vennootschap";
    }
    else {
        return "Natuurlijk persoon";
    }
}

export class DossierOwnerCompany extends Record {
    constructor(CompanyName, CompanyType, Address, PhoneNumber, VatNumber, Email, IsVME, IsSocialHousingCompany, FirstName, LastName) {
        super();
        this.CompanyName = CompanyName;
        this.CompanyType = CompanyType;
        this.Address = Address;
        this.PhoneNumber = PhoneNumber;
        this.VatNumber = VatNumber;
        this.Email = Email;
        this.IsVME = IsVME;
        this.IsSocialHousingCompany = IsSocialHousingCompany;
        this.FirstName = FirstName;
        this.LastName = LastName;
    }
}

export function DossierOwnerCompany$reflection() {
    return record_type("Domain.DossierOwnerCompany", [], DossierOwnerCompany, () => [["CompanyName", NonEmptyString$reflection()], ["CompanyType", option_type(NonEmptyString$reflection())], ["Address", Address$reflection()], ["PhoneNumber", option_type(PhoneNumber$reflection())], ["VatNumber", VatNumber$reflection()], ["Email", Email$reflection()], ["IsVME", bool_type], ["IsSocialHousingCompany", bool_type], ["FirstName", option_type(NonEmptyString$reflection())], ["LastName", option_type(NonEmptyString$reflection())]]);
}

export class DossierOwnerPerson extends Record {
    constructor(FirstName, LastName, Address, PhoneNumber, Email) {
        super();
        this.FirstName = FirstName;
        this.LastName = LastName;
        this.Address = Address;
        this.PhoneNumber = PhoneNumber;
        this.Email = Email;
    }
}

export function DossierOwnerPerson$reflection() {
    return record_type("Domain.DossierOwnerPerson", [], DossierOwnerPerson, () => [["FirstName", NonEmptyString$reflection()], ["LastName", NonEmptyString$reflection()], ["Address", Address$reflection()], ["PhoneNumber", option_type(PhoneNumber$reflection())], ["Email", Email$reflection()]]);
}

export class DossierOwner extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["Person", "Company"];
    }
}

export function DossierOwner$reflection() {
    return union_type("Domain.DossierOwner", [], DossierOwner, () => [[["Item", DossierOwnerPerson$reflection()]], [["Item", DossierOwnerCompany$reflection()]]]);
}

export function DossierOwner__get_Address(this$) {
    if (this$.tag === 1) {
        return this$.fields[0].Address;
    }
    else {
        return this$.fields[0].Address;
    }
}

export class CreateQuoteData extends Record {
    constructor(TypeOfDossier, InspectionLocation, InspectionLocationOther, Client, BuildingDetail, HousingUnit, YearsOfConstruction, YearsOfRenovation, AwareOfAsbestosDescription, IsUserOwnerOfInspectionArea, Address, EmailConfirmations, Status, SyndicId, LegalRepresentativeId, DossierOwner, ManualInvoice, ManualInvoice_EmailSent, HiddenAsbestos, FloorPlanAvailable, OwnerStatus, OwnerStatusOther, Discount, IsCibDossier, InspectionLocationBerging, InspectionLocationStaanplaats, InspectionLocationGaragebox, IsUrgent, CompensationAmount, IsRealSmartDossier, CustomPrice, NumberOfEntrances, HallwaysPerLevel, PipeIsolationMeters, BoilerRoom, SharedAreaOption1, SharedAreaOption2, SharedAreaOption3, SharedAreaOption4) {
        super();
        this.TypeOfDossier = TypeOfDossier;
        this.InspectionLocation = InspectionLocation;
        this.InspectionLocationOther = InspectionLocationOther;
        this.Client = Client;
        this.BuildingDetail = BuildingDetail;
        this.HousingUnit = HousingUnit;
        this.YearsOfConstruction = YearsOfConstruction;
        this.YearsOfRenovation = YearsOfRenovation;
        this.AwareOfAsbestosDescription = AwareOfAsbestosDescription;
        this.IsUserOwnerOfInspectionArea = IsUserOwnerOfInspectionArea;
        this.Address = Address;
        this.EmailConfirmations = EmailConfirmations;
        this.Status = Status;
        this.SyndicId = SyndicId;
        this.LegalRepresentativeId = LegalRepresentativeId;
        this.DossierOwner = DossierOwner;
        this.ManualInvoice = ManualInvoice;
        this.ManualInvoice_EmailSent = ManualInvoice_EmailSent;
        this.HiddenAsbestos = HiddenAsbestos;
        this.FloorPlanAvailable = FloorPlanAvailable;
        this.OwnerStatus = OwnerStatus;
        this.OwnerStatusOther = OwnerStatusOther;
        this.Discount = Discount;
        this.IsCibDossier = IsCibDossier;
        this.InspectionLocationBerging = InspectionLocationBerging;
        this.InspectionLocationStaanplaats = InspectionLocationStaanplaats;
        this.InspectionLocationGaragebox = InspectionLocationGaragebox;
        this.IsUrgent = IsUrgent;
        this.CompensationAmount = CompensationAmount;
        this.IsRealSmartDossier = IsRealSmartDossier;
        this.CustomPrice = CustomPrice;
        this.NumberOfEntrances = NumberOfEntrances;
        this.HallwaysPerLevel = HallwaysPerLevel;
        this.PipeIsolationMeters = PipeIsolationMeters;
        this.BoilerRoom = BoilerRoom;
        this.SharedAreaOption1 = SharedAreaOption1;
        this.SharedAreaOption2 = SharedAreaOption2;
        this.SharedAreaOption3 = SharedAreaOption3;
        this.SharedAreaOption4 = SharedAreaOption4;
    }
}

export function CreateQuoteData$reflection() {
    return record_type("Domain.CreateQuoteData", [], CreateQuoteData, () => [["TypeOfDossier", TypeOfDossierData$reflection()], ["InspectionLocation", SelectOptionData$1$reflection(InspectionLocation$reflection())], ["InspectionLocationOther", option_type(NonEmptyString$reflection())], ["Client", SelectOptionData$1$reflection(DossierClient$reflection())], ["BuildingDetail", option_type(NonEmptyString$reflection())], ["HousingUnit", option_type(NonEmptyString$reflection())], ["YearsOfConstruction", option_type(NonEmptyString$reflection())], ["YearsOfRenovation", option_type(NonEmptyString$reflection())], ["AwareOfAsbestosDescription", option_type(NonEmptyString$reflection())], ["IsUserOwnerOfInspectionArea", bool_type], ["Address", Address$reflection()], ["EmailConfirmations", bool_type], ["Status", DossierStatus$reflection()], ["SyndicId", option_type(PartnerId$reflection())], ["LegalRepresentativeId", option_type(LegalRepresentativeId$reflection())], ["DossierOwner", DossierOwner$reflection()], ["ManualInvoice", bool_type], ["ManualInvoice_EmailSent", bool_type], ["HiddenAsbestos", option_type(bool_type)], ["FloorPlanAvailable", option_type(bool_type)], ["OwnerStatus", SelectOptionData$1$reflection(OwnerStatus$reflection())], ["OwnerStatusOther", option_type(NonEmptyString$reflection())], ["Discount", TypeOfDiscount$reflection()], ["IsCibDossier", bool_type], ["InspectionLocationBerging", option_type(bool_type)], ["InspectionLocationStaanplaats", option_type(bool_type)], ["InspectionLocationGaragebox", option_type(bool_type)], ["IsUrgent", bool_type], ["CompensationAmount", option_type(Compensation$reflection())], ["IsRealSmartDossier", bool_type], ["CustomPrice", option_type(Decimal$reflection())], ["NumberOfEntrances", option_type(NonEmptyString$reflection())], ["HallwaysPerLevel", option_type(NonEmptyString$reflection())], ["PipeIsolationMeters", option_type(NonEmptyString$reflection())], ["BoilerRoom", bool_type], ["SharedAreaOption1", option_type(NonEmptyString$reflection())], ["SharedAreaOption2", option_type(NonEmptyString$reflection())], ["SharedAreaOption3", option_type(NonEmptyString$reflection())], ["SharedAreaOption4", option_type(NonEmptyString$reflection())]]);
}

export class CreateQuoteDataContact extends Record {
    constructor(AssignmentContactEmail, AssignmentDocumentContact, CertificateCustomEmails, CertificateEmailClient, CertificateEmailCustom, CertificateEmailPartner, HomeVisitContact, HomeVisitContactName, HomeVisitContactEmail, InvoicingParty, InvoicePricing) {
        super();
        this.AssignmentContactEmail = AssignmentContactEmail;
        this.AssignmentDocumentContact = AssignmentDocumentContact;
        this.CertificateCustomEmails = CertificateCustomEmails;
        this.CertificateEmailClient = CertificateEmailClient;
        this.CertificateEmailCustom = CertificateEmailCustom;
        this.CertificateEmailPartner = CertificateEmailPartner;
        this.HomeVisitContact = HomeVisitContact;
        this.HomeVisitContactName = HomeVisitContactName;
        this.HomeVisitContactEmail = HomeVisitContactEmail;
        this.InvoicingParty = InvoicingParty;
        this.InvoicePricing = InvoicePricing;
    }
}

export function CreateQuoteDataContact$reflection() {
    return record_type("Domain.CreateQuoteDataContact", [], CreateQuoteDataContact, () => [["AssignmentContactEmail", option_type(NonEmptyString$reflection())], ["AssignmentDocumentContact", AssignmentDocument$reflection()], ["CertificateCustomEmails", option_type(NonEmptyString$reflection())], ["CertificateEmailClient", bool_type], ["CertificateEmailCustom", bool_type], ["CertificateEmailPartner", bool_type], ["HomeVisitContact", option_type(HomeVisitContact$reflection())], ["HomeVisitContactName", option_type(NonEmptyString$reflection())], ["HomeVisitContactEmail", option_type(PhoneNumber$reflection())], ["InvoicingParty", DossierCustomer$reflection()], ["InvoicePricing", InvoicePricing$reflection()]]);
}

export class CreateQuoteData2 extends Record {
    constructor(CreateQuoteData, CreateQuoteDataContact, QuoteDocuments) {
        super();
        this.CreateQuoteData = CreateQuoteData;
        this.CreateQuoteDataContact = CreateQuoteDataContact;
        this.QuoteDocuments = QuoteDocuments;
    }
}

export function CreateQuoteData2$reflection() {
    return record_type("Domain.CreateQuoteData2", [], CreateQuoteData2, () => [["CreateQuoteData", CreateQuoteData$reflection()], ["CreateQuoteDataContact", CreateQuoteDataContact$reflection()], ["QuoteDocuments", list_type(QuoteDocumentUploadResult$reflection())]]);
}

export class CreateDossierData extends Record {
    constructor(TypeOfDossier, InspectionLocation, InspectionLocationOther, ResidentialBerging, ResidentialGaragebox, Client, BuildingDetail, HousingUnit, YearsOfConstruction, YearsOfRenovation, AwareOfAsbestosDescription, IsUserOwnerOfInspectionArea, Address, EmailConfirmations, Status, PartnerId, LegalRepresentativeId, DossierOwner, ManualInvoice, ManualInvoice_EmailSent, HiddenAsbestos, FloorPlanAvailable, OwnerStatus, OwnerStatusOther, Discount, IsCibDossier, InspectionLocationBerging, InspectionLocationStaanplaats, InspectionLocationGaragebox, IsUrgent, CompensationAmount, IsRealSmartDossier, QuoteApprovalMeetingDate, NumberOfEntrances, HallwaysPerLevel, PipeIsolationMeters, BoilerRoom, SharedAreaOption1, SharedAreaOption2, SharedAreaOption3, SharedAreaOption4, AdditionalGarage, AdditionalGardenbox, AdditionalGreenhouse, ExistingAsbestosAttest, ExistingAsbestosAttestNumbers, ExistingAsbestosAttestSplit, ExistingAsbestosAttestExpired, ExistingAsbestosAttestMaterialChanged, ExistingAsbestosAttestRestrictionLifted, ExistingAsbestosAttestOther, ExistingAsbestosAttestOtherDescription, AsbestInventoryOtherDescription, AllowInvoice, Kind, EpcScore, WoonhuisBuildingForm, AssignedAdiId, LinkedDossierId) {
        super();
        this.TypeOfDossier = TypeOfDossier;
        this.InspectionLocation = InspectionLocation;
        this.InspectionLocationOther = InspectionLocationOther;
        this.ResidentialBerging = ResidentialBerging;
        this.ResidentialGaragebox = ResidentialGaragebox;
        this.Client = Client;
        this.BuildingDetail = BuildingDetail;
        this.HousingUnit = HousingUnit;
        this.YearsOfConstruction = YearsOfConstruction;
        this.YearsOfRenovation = YearsOfRenovation;
        this.AwareOfAsbestosDescription = AwareOfAsbestosDescription;
        this.IsUserOwnerOfInspectionArea = IsUserOwnerOfInspectionArea;
        this.Address = Address;
        this.EmailConfirmations = EmailConfirmations;
        this.Status = Status;
        this.PartnerId = PartnerId;
        this.LegalRepresentativeId = LegalRepresentativeId;
        this.DossierOwner = DossierOwner;
        this.ManualInvoice = ManualInvoice;
        this.ManualInvoice_EmailSent = ManualInvoice_EmailSent;
        this.HiddenAsbestos = HiddenAsbestos;
        this.FloorPlanAvailable = FloorPlanAvailable;
        this.OwnerStatus = OwnerStatus;
        this.OwnerStatusOther = OwnerStatusOther;
        this.Discount = Discount;
        this.IsCibDossier = IsCibDossier;
        this.InspectionLocationBerging = InspectionLocationBerging;
        this.InspectionLocationStaanplaats = InspectionLocationStaanplaats;
        this.InspectionLocationGaragebox = InspectionLocationGaragebox;
        this.IsUrgent = IsUrgent;
        this.CompensationAmount = CompensationAmount;
        this.IsRealSmartDossier = IsRealSmartDossier;
        this.QuoteApprovalMeetingDate = QuoteApprovalMeetingDate;
        this.NumberOfEntrances = NumberOfEntrances;
        this.HallwaysPerLevel = HallwaysPerLevel;
        this.PipeIsolationMeters = PipeIsolationMeters;
        this.BoilerRoom = BoilerRoom;
        this.SharedAreaOption1 = SharedAreaOption1;
        this.SharedAreaOption2 = SharedAreaOption2;
        this.SharedAreaOption3 = SharedAreaOption3;
        this.SharedAreaOption4 = SharedAreaOption4;
        this.AdditionalGarage = AdditionalGarage;
        this.AdditionalGardenbox = AdditionalGardenbox;
        this.AdditionalGreenhouse = AdditionalGreenhouse;
        this.ExistingAsbestosAttest = ExistingAsbestosAttest;
        this.ExistingAsbestosAttestNumbers = ExistingAsbestosAttestNumbers;
        this.ExistingAsbestosAttestSplit = ExistingAsbestosAttestSplit;
        this.ExistingAsbestosAttestExpired = ExistingAsbestosAttestExpired;
        this.ExistingAsbestosAttestMaterialChanged = ExistingAsbestosAttestMaterialChanged;
        this.ExistingAsbestosAttestRestrictionLifted = ExistingAsbestosAttestRestrictionLifted;
        this.ExistingAsbestosAttestOther = ExistingAsbestosAttestOther;
        this.ExistingAsbestosAttestOtherDescription = ExistingAsbestosAttestOtherDescription;
        this.AsbestInventoryOtherDescription = AsbestInventoryOtherDescription;
        this.AllowInvoice = AllowInvoice;
        this.Kind = Kind;
        this.EpcScore = EpcScore;
        this.WoonhuisBuildingForm = WoonhuisBuildingForm;
        this.AssignedAdiId = AssignedAdiId;
        this.LinkedDossierId = LinkedDossierId;
    }
}

export function CreateDossierData$reflection() {
    return record_type("Domain.CreateDossierData", [], CreateDossierData, () => [["TypeOfDossier", TypeOfDossierData$reflection()], ["InspectionLocation", SelectOptionData$1$reflection(InspectionLocation$reflection())], ["InspectionLocationOther", option_type(NonEmptyString$reflection())], ["ResidentialBerging", option_type(NonEmptyString$reflection())], ["ResidentialGaragebox", option_type(NonEmptyString$reflection())], ["Client", SelectOptionData$1$reflection(DossierClient$reflection())], ["BuildingDetail", option_type(NonEmptyString$reflection())], ["HousingUnit", option_type(NonEmptyString$reflection())], ["YearsOfConstruction", option_type(NonEmptyString$reflection())], ["YearsOfRenovation", option_type(NonEmptyString$reflection())], ["AwareOfAsbestosDescription", option_type(NonEmptyString$reflection())], ["IsUserOwnerOfInspectionArea", bool_type], ["Address", Address$reflection()], ["EmailConfirmations", bool_type], ["Status", DossierStatus$reflection()], ["PartnerId", option_type(PartnerId$reflection())], ["LegalRepresentativeId", option_type(LegalRepresentativeId$reflection())], ["DossierOwner", DossierOwner$reflection()], ["ManualInvoice", bool_type], ["ManualInvoice_EmailSent", bool_type], ["HiddenAsbestos", option_type(bool_type)], ["FloorPlanAvailable", option_type(bool_type)], ["OwnerStatus", SelectOptionData$1$reflection(OwnerStatus$reflection())], ["OwnerStatusOther", option_type(NonEmptyString$reflection())], ["Discount", TypeOfDiscount$reflection()], ["IsCibDossier", bool_type], ["InspectionLocationBerging", option_type(bool_type)], ["InspectionLocationStaanplaats", option_type(bool_type)], ["InspectionLocationGaragebox", option_type(bool_type)], ["IsUrgent", bool_type], ["CompensationAmount", option_type(Compensation$reflection())], ["IsRealSmartDossier", bool_type], ["QuoteApprovalMeetingDate", option_type(class_type("System.DateTimeOffset"))], ["NumberOfEntrances", option_type(NonEmptyString$reflection())], ["HallwaysPerLevel", option_type(NonEmptyString$reflection())], ["PipeIsolationMeters", option_type(NonEmptyString$reflection())], ["BoilerRoom", bool_type], ["SharedAreaOption1", option_type(NonEmptyString$reflection())], ["SharedAreaOption2", option_type(NonEmptyString$reflection())], ["SharedAreaOption3", option_type(NonEmptyString$reflection())], ["SharedAreaOption4", option_type(NonEmptyString$reflection())], ["AdditionalGarage", option_type(NonEmptyString$reflection())], ["AdditionalGardenbox", option_type(NonEmptyString$reflection())], ["AdditionalGreenhouse", option_type(NonEmptyString$reflection())], ["ExistingAsbestosAttest", option_type(bool_type)], ["ExistingAsbestosAttestNumbers", option_type(NonEmptyString$reflection())], ["ExistingAsbestosAttestSplit", option_type(bool_type)], ["ExistingAsbestosAttestExpired", option_type(bool_type)], ["ExistingAsbestosAttestMaterialChanged", option_type(bool_type)], ["ExistingAsbestosAttestRestrictionLifted", option_type(bool_type)], ["ExistingAsbestosAttestOther", option_type(bool_type)], ["ExistingAsbestosAttestOtherDescription", option_type(NonEmptyString$reflection())], ["AsbestInventoryOtherDescription", option_type(NonEmptyString$reflection())], ["AllowInvoice", bool_type], ["Kind", DossierKind$reflection()], ["EpcScore", option_type(EpcScore$reflection())], ["WoonhuisBuildingForm", option_type(WoonhuisBuildingForm$reflection())], ["AssignedAdiId", option_type(AdiId$reflection())], ["LinkedDossierId", option_type(DossierId$reflection())]]);
}

export class DossierCustomerData extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["Partner", "Customer"];
    }
}

export function DossierCustomerData$reflection() {
    return union_type("Domain.DossierCustomerData", [], DossierCustomerData, () => [[["Item1", CustomerCode$reflection()], ["Item2", CustomerId$reflection()], ["Item3", PartnerId$reflection()]], [["Item1", CustomerCode$reflection()], ["Item2", CustomerId$reflection()]]]);
}

export class CreateDossierDataContact extends Record {
    constructor(AssignmentContactEmail, AssignmentDocumentContact, CertificateCustomEmails, CertificateEmailClient, CertificateEmailCustom, CertificateEmailPartner, HomeVisitContact, HomeVisitContactName, HomeVisitContactEmail, InvoicingParty, InvoicePricing) {
        super();
        this.AssignmentContactEmail = AssignmentContactEmail;
        this.AssignmentDocumentContact = AssignmentDocumentContact;
        this.CertificateCustomEmails = CertificateCustomEmails;
        this.CertificateEmailClient = CertificateEmailClient;
        this.CertificateEmailCustom = CertificateEmailCustom;
        this.CertificateEmailPartner = CertificateEmailPartner;
        this.HomeVisitContact = HomeVisitContact;
        this.HomeVisitContactName = HomeVisitContactName;
        this.HomeVisitContactEmail = HomeVisitContactEmail;
        this.InvoicingParty = InvoicingParty;
        this.InvoicePricing = InvoicePricing;
    }
}

export function CreateDossierDataContact$reflection() {
    return record_type("Domain.CreateDossierDataContact", [], CreateDossierDataContact, () => [["AssignmentContactEmail", option_type(NonEmptyString$reflection())], ["AssignmentDocumentContact", AssignmentDocument$reflection()], ["CertificateCustomEmails", option_type(NonEmptyString$reflection())], ["CertificateEmailClient", bool_type], ["CertificateEmailCustom", bool_type], ["CertificateEmailPartner", bool_type], ["HomeVisitContact", HomeVisitContact$reflection()], ["HomeVisitContactName", option_type(NonEmptyString$reflection())], ["HomeVisitContactEmail", option_type(PhoneNumber$reflection())], ["InvoicingParty", DossierCustomer$reflection()], ["InvoicePricing", InvoicePricing$reflection()]]);
}

export class CreateDossierData2 extends Record {
    constructor(CreateDossierData, CreateDossierDataContact) {
        super();
        this.CreateDossierData = CreateDossierData;
        this.CreateDossierDataContact = CreateDossierDataContact;
    }
}

export function CreateDossierData2$reflection() {
    return record_type("Domain.CreateDossierData2", [], CreateDossierData2, () => [["CreateDossierData", CreateDossierData$reflection()], ["CreateDossierDataContact", CreateDossierDataContact$reflection()]]);
}

export class AdiOption extends Record {
    constructor(Label, Id) {
        super();
        this.Label = Label;
        this.Id = (Id | 0);
    }
}

export function AdiOption$reflection() {
    return record_type("Domain.AdiOption", [], AdiOption, () => [["Label", string_type], ["Id", int32_type]]);
}

export function AdiOption_get_none() {
    return new AdiOption("Geen", 0);
}

export class Quarter extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["Q1", "Q2", "Q3", "Q4", "Custom"];
    }
}

export function Quarter$reflection() {
    return union_type("Domain.Quarter", [], Quarter, () => [[], [], [], [], []]);
}

export class AssignmentConfirmationResult extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["AssignmentConfirmationGenerated", "AssignmentConfirmationNotGenerated"];
    }
}

export function AssignmentConfirmationResult$reflection() {
    return union_type("Domain.AssignmentConfirmationResult", [], AssignmentConfirmationResult, () => [[["Item", string_type]], [["Item", string_type]]]);
}

export class UpdateDossierResult extends Record {
    constructor(Id, Code, AssignmentConfirmationResult) {
        super();
        this.Id = Id;
        this.Code = Code;
        this.AssignmentConfirmationResult = AssignmentConfirmationResult;
    }
}

export function UpdateDossierResult$reflection() {
    return record_type("Domain.UpdateDossierResult", [], UpdateDossierResult, () => [["Id", DossierId$reflection()], ["Code", DossierCode$reflection()], ["AssignmentConfirmationResult", AssignmentConfirmationResult$reflection()]]);
}

